import './QualityControl.css';
import {Context} from '../Context';
import React, { useContext, useEffect, useState, useMemo, useCallback, useRef} from 'react';
import QualityControlService from '../Services/QualityControlService';

const baseRoutePath = 'https://cornerstoneinc.io/QCViewer/';

const helpURL = 'https://cornerstonedetentionproducts.box.com/s/vt0fc2j5je4c7167kwhkbvl46mhu0oj0';

const branchList = {
    '02': {
        name: 'Construction (DEC) - Hartselle, AL',
    },
    '04': {
        name: 'Electronics (SEC) - Montgomery, AL',
    },
    '09': {
        name: 'Precast / Modular - KOP, PA',
    }
};

const getAllProjects = async (apiToken, setSuccess, setFailure, setTimestamp) => {
    try {
        const response = await QualityControlService.getAllProjects(apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
            setTimestamp(new Date().toISOString());
            console.log(response.data)
        } else {
            console.error('Error fetching projects:', response);
            setFailure(`Error: Received status code ${response.status}`);
        }
    } catch (error) {
        console.error('Error fetching projects:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const submitQCList = async (apiToken, projectId, qcList, updateProjectQCList, updateProjectStats, setFailure, closeProjectDetails,  deleteNotFound) => {
    try {
        const response = await QualityControlService.uploadQCList(apiToken, projectId, qcList, deleteNotFound);
        if (response.status > 199 && response.status < 300) {
            console.log(response.data)
            updateProjectQCList(response.data.qcList);
            updateProjectStats(response.data.qcStatistics);
            closeProjectDetails();
            return true;
        } else {
            console.error('Error submitting QC list:', response);
            setFailure(`Error: Received status code ${response.status}`);
            return false;
        }
    } catch (error) {
        console.error('Error submitting QC list:', error);
        setFailure(`Error: ${error.message}`);
        return false;
    };
};

const getQCTemplate = async () => {
    QualityControlService.getQCTemplate();
};

const importQCList = async (apiToken, importDocument, setSuccess, setFailure) => {
    try {
        const response = await QualityControlService.importQCList(apiToken, importDocument);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data);
            return true;
        } else {
            console.error('Error importing QC list:', response);
            setFailure(`Error: Received status code ${response.status}`);
            return false;
        }
    } catch (error) {
        console.error('Error importing QC list:', error);
        setFailure(`Error: ${error.message}`);
        return false;
    };
};

const getQCCategoriesList = async (setSuccess, setFailure) => {
    QualityControlService.getQCCategoriesList().then((response) => {
        if(response.status > 199 && response.status < 300) {
            setSuccess(response.data);
        } else {
            console.error('Error fetching QC categories:', response);
            setFailure(`Error: Received status code ${response.status}`);
        }
    }).catch((error) => {
        console.error('Error fetching QC categories:', error);
        setFailure(`Error: ${error.message}`);
    });
};

const getQCProjectData = async (apiToken, projectId, setQCList, setQCStats, setSuccess, setFailure) => {
    try {
        const response = await QualityControlService.getQCDataByProject(apiToken, projectId);
        if (response.status > 199 && response.status < 300) {
            setQCList(response.data.qcList);
            setQCStats(response.data.qcStatistics);
            setSuccess();
        } else {
            console.error('Error fetching QC project data:', response);
            setFailure(`Error: Received status code ${response.status}`);
        }
    } catch (error) {
        console.error('Error fetching QC project data:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const generateCompleteQCReport = async (apiToken, setSuccess, setFailure) => {
    try {
        const response = await QualityControlService.getCompleteQCReport(apiToken);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data.filename);
            downloadCompleteQCReport(apiToken, response.data.filename);
        } else {
            console.error('Error generating complete QC report:', response);
            setFailure(`Error: Received status code ${response.status}`);
        }
    } catch (error) {
        console.error('Error generating complete QC report:', error);
        setFailure(`Error: ${error.message}`);
    };
};

const downloadCompleteQCReport = (apiToken,filename) => {
    QualityControlService.downloadCompleteQCReport(apiToken, filename);
};

const getInitializedTemplate = async () => {
    QualityControlService.getInitializedTemplate();
};

const submitCompleteInitializedFile = async (apiToken, initializedFile, setInitializedObject, setError) => {
    QualityControlService.submitInitializedFile(apiToken, initializedFile).then((response) => {
        if (response.status > 199 && response.status < 300) {
            console.log(response.data)
            setInitializedObject(response.data);
        }
    }).catch((error) => {
        setError(`Error: ${error.message}`);
    });
};

const submitCompleteInitializedObject = async (apiToken, projectId, initializedObject, setError, closeWindow, refreshSelectedProjectData) => {
    QualityControlService.submitInitializedObject(apiToken, projectId, initializedObject.importedData).then((response) => {
        if (response.status > 199 && response.status < 300) {
            refreshSelectedProjectData();
            closeWindow();
        }
    }).catch((error) => {
        setError(`Error: ${error.message}`);
    });
};

const createProjectSpecificReport = async (apiToken, projectId, setSuccess, setFailure) => {
    try {
        const response = await QualityControlService.getProjectSpecificReport(apiToken, projectId);
        if (response.status > 199 && response.status < 300) {
            setSuccess(response.data.filename);
            downloadProjectSpecificReport(apiToken, response.data.filename);
        } else {
            console.error('Error generating project specific QC report:', response);
            setFailure(`Error: Received status code ${response.status}`);
        }
    } catch (error) {
        console.error('Error generating project specific QC report:', error);
        setFailure(`Error: ${error.message}`);
    }
};

const downloadProjectSpecificReport = (apiToken, filename) => {
    QualityControlService.downloadProjectSpecificReport(apiToken, filename);
};

const importQCListUpdate = async (apiToken, importDocument, setImportUpdateSuccess, setImportUpdateFailure, setImportUpdateProcessing, projectNumber,refreshSelectedProjectData) => {
    try {
        const response = await QualityControlService.importQCListUpdate(apiToken, importDocument, projectNumber);
        if (response.status > 199 && response.status < 300) {
            setImportUpdateProcessing(false);
            setImportUpdateSuccess(true);
            refreshSelectedProjectData();
        } else {
            console.error('Error importing QC list update:', response);
            setImportUpdateProcessing(false);
            setImportUpdateFailure(true);
        };
    } catch (error) {
        console.error('Error importing QC list update:', error);
        setImportUpdateProcessing(false);
        setImportUpdateFailure(true);
    };
};

const getAllProjectQcIssueLogs = async (apiToken, projectId, setIssueLogs, setError) => {
    QualityControlService.getAllProjectIssueLogs(apiToken, projectId).then((response) => {
        if (response.status > 199 && response.status < 300) {
            console.log(response.data)
            setIssueLogs(response.data);
        }
    }).catch((error) => {
        setError(`Error: ${error.message}`);
    });
};

// - - - - - CALLS TO API ABOVE - - - - - 

// Get the status color for a QC item row
const getRowStatusColor = (item, categoryFields) => {
    // Check if installDate is filled out
    const hasInstallDate = item.installDate && item.installDate.toString().trim() !== '';
    
    // Get all inspection type fields
    const inspectionFields = Object.keys(categoryFields).filter(
        key => categoryFields[key].type === 'inspection'
    );
    
    if (inspectionFields.length === 0) {
        // No inspection fields, return yellow if installed date exists, white otherwise
        return hasInstallDate ? '#ffeb3b' : '#ffffff'; // yellow : white
    }
    
    // Get inspection values
    const inspectionValues = inspectionFields
        .map(field => item[field])
        .filter(value => value !== undefined && value !== null && value !== '');
    
    // Check if any inspection failed (highest priority)
    const hasFail = inspectionValues.some(value => value === 'fail');
    if (hasFail) {
        return '#dc3545'; // red
    }
    
    // Check if all inspections are complete (pass or N/A)
    const allComplete = inspectionFields.length > 0 && 
        inspectionFields.every(field => {
            const value = item[field];
            return value === 'pass' || value === 'N/A';
        });
    
    if (allComplete) {
        return '#28a745'; // green
    }
    
    // Check if some inspections have entries but not all complete
    const hasPartialInspections = inspectionValues.length > 0;
    if (hasPartialInspections) {
        return '#ffc107'; // orange
    }
    
    // If no inspection activity but has install date, show yellow
    if (hasInstallDate) {
        return '#ffeb3b'; // yellow
    }

    if(item.receivedDate && !hasInstallDate) return '#00ccff'; // blue 
    
    // Default case - no install date and no inspection activity
    return '#ffffff'; // white
};

// Format date to MM/DD/YY
const formatDateToDisplay = (dateString) => {
    if (!dateString) return '';
    
    // If it's already in MM/DD/YY format, return it
    if (/^\d{1,2}\/\d{1,2}\/\d{2}$/.test(dateString)) {
        // Check if it's 01/01/01 and return N/A
        if (dateString === '01/01/01') {
            return 'N/A';
        }
        return dateString;
    }
    
    // Parse YYYY-MM-DD format directly without Date object to avoid timezone issues
    const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
        const [, year, month, day] = match;
        
        // Check if it's 0001-01-01 and return N/A
        if ((year === '0001') && month === '01' && day === '01') {
            return 'N/A';
        }
        
        const shortYear = year.slice(-2);
        // Remove leading zeros from month and day, then pad if needed
        const displayMonth = String(parseInt(month, 10)).padStart(2, '0');
        const displayDay = String(parseInt(day, 10)).padStart(2, '0');
        return `${displayMonth}/${displayDay}/${shortYear}`;
    }
    
    return dateString; // Return original if can't parse
};

const formatDateTimeToDisplay = (dateString) => {
    if (!dateString) return '';
    const parsedDate = new Date(dateString);
    if (Number.isNaN(parsedDate.getTime())) {
        return dateString;
    }
    return `${parsedDate.toLocaleDateString()} ${parsedDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
};

const normalizeIssueType = (value) => {
    if (!value) return '';
    return value.toString().trim().toLowerCase().replace(/[\s_-]+/g, '');
};

const normalizeReferenceId = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const issueTypeMatchesSection = (issueType, sectionName) => {
    const normalizedIssueType = normalizeIssueType(issueType);
    const normalizedSectionName = normalizeIssueType(sectionName);

    if (!normalizedIssueType || !normalizedSectionName) return false;
    if (normalizedIssueType === normalizedSectionName) return true;

    const singularize = (value) => (value.endsWith('s') ? value.slice(0, -1) : value);
    return singularize(normalizedIssueType) === singularize(normalizedSectionName);
};

const parseDateFromPaste = (input) => {
    if (!input) return null;
    
    // Handle 6-digit format like 112325 -> 11/23/25
    if (/^\d{6}$/.test(input)) {
        const month = parseInt(input.substring(0, 2), 10);
        const day = parseInt(input.substring(2, 4), 10);
        let year = parseInt(input.substring(4, 6), 10);
        
        // Convert 2-digit year to 4-digit
        year = year < 50 ? 2000 + year : 1900 + year;
        
        // Validate the date components
        if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
            const paddedMonth = String(month).padStart(2, '0');
            const paddedDay = String(day).padStart(2, '0');
            return `${year}-${paddedMonth}-${paddedDay}`;
        }
    }
    
    // Handle MM/DD/YY format
    const parts = input.split('/');
    if (parts.length === 3) {
        let [month, day, year] = parts.map(part => parseInt(part, 10));
        
        if (!isNaN(month) && !isNaN(day) && !isNaN(year)) {
            // Handle 2-digit years
            if (year < 100) {
                year = year < 50 ? 2000 + year : 1900 + year;
            }
            
            // Validate the date components
            if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                // Format directly to YYYY-MM-DD without creating a Date object
                // This avoids timezone conversion issues
                const paddedMonth = String(month).padStart(2, '0');
                const paddedDay = String(day).padStart(2, '0');
                return `${year}-${paddedMonth}-${paddedDay}`;
            }
        }
    }
    return null;
};

const getInspectionSymbol = (value) => {
    if (value === 'pass') return { symbol: '✓', class: 'pass' };
    if (value === 'fail') return { symbol: '✗', class: 'fail' };
    if (value === 'N/A') return { symbol: '—', class: 'na' };
    return { symbol: '', class: '' };
};

const getNormalizedAreaValue = (value) => {
    return (value ?? '').toString().trim().toLowerCase();
};

const getItemAreaValue = (item) => {
    return item?.area ?? item?.Area ?? item?.areaName ?? item?.AreaName ?? '';
};

const itemMatchesArea = (item, areaName) => {
    return getNormalizedAreaValue(getItemAreaValue(item)) === getNormalizedAreaValue(areaName);
};

const ProjectsDisplay = ({apiToken, filteredProjects, projectsError, setSelectedProject, branchFilters}) => {
    const [collapsedBranches, setCollapsedBranches] = useState({});
    const [hoveredProject, setHoveredProject] = useState(null);

    const toggleBranchCollapse = (branch) => {
        setCollapsedBranches(prev => ({
            ...prev,
            [branch]: !prev[branch]
        }));
    };

    if (projectsError) {
        return (
            <div className="projects-display">
                <div className="projects-display-error">
                    <div className="error-icon">⚠</div>
                    <h3>Unable to Load Projects</h3>
                    <p>{projectsError}</p>
                </div>
            </div>
        );
    };

    if (!filteredProjects) {
        return (
            <div className="projects-display">
                <div className="projects-display-loading">
                    <div className="qc-loading-spinner"></div>
                    <p>Loading projects...</p>
                </div>
            </div>
        );
    };

    // Get sorted branch keys (02, 09, etc.)
    let sortedBranches = Object.keys(filteredProjects).sort((a, b) => parseInt(a) - parseInt(b));
    
    // Apply branch filters if any are selected
    if (branchFilters.length > 0) {
        sortedBranches = sortedBranches.filter(branch => branchFilters.includes(branch));
    }

    return (
        <div className="projects-display">
            {sortedBranches.map(branch => {
                // Only show branch if it has projects
                if (!filteredProjects[branch] || filteredProjects[branch].length === 0) {
                    return null;
                }
                
                return (
                <div key={branch} className="branch-section">
                    <div 
                        className="qc-branch-header" 
                        onClick={() => toggleBranchCollapse(branch)}
                        style={{ cursor: 'pointer' }}
                    >
                        <span className="qc-branch-collapse-icon">
                            {collapsedBranches[branch] ? '▶' : '▼'}
                        </span>
                        {branch} - {branchList[branch]?.name || ''}
                    </div>
                    {!collapsedBranches[branch] && (
                        <div className="qc-projects-list">
                        {filteredProjects[branch].map((project, index) => (
                            <div 
                                key={project.project_number || index} 
                                className="qc-project-item" 
                                onClick={() => setSelectedProject(project)}
                                onMouseEnter={() => setHoveredProject(project.project_number || index)}
                                onMouseLeave={() => setHoveredProject(null)}
                            >
                                <div className="qc-project-item-header">
                                    {project.displayName}
                                </div>
                                {
                                    // Add the totals progress bar here qcStatistics.total
                                }
                                {project.qcStatistics && (
                                    <div className="qc-project-item-summary">
                                        {/* Total statistics bar - always visible */}
                                        {project.qcStatistics.total && (
                                            <div className="qc-project-summary-category">
                                                <div className="qc-project-summary-category-name">{project.qcStatistics.total.displayName}</div>
                                                <div className="qc-project-summary-bars">
                                                    <div className="qc-project-summary-bar-container">
                                                        <div 
                                                            className="qc-project-summary-bar qc-bar-onsite" 
                                                            style={{ width: `${project.qcStatistics.total.percentOnsite}%` }}
                                                            title={`Onsite: ${project.qcStatistics.total.onsite}/${project.qcStatistics.total.total} (${Math.round(project.qcStatistics.total.percentOnsite)}%)`}
                                                        ></div>
                                                        <div 
                                                            className="qc-project-summary-bar qc-bar-installed" 
                                                            style={{ width: `${project.qcStatistics.total.percentInstalled}%` }}
                                                            title={`Installed: ${project.qcStatistics.total.installed}/${project.qcStatistics.total.total} (${Math.round(project.qcStatistics.total.percentInstalled)}%)`}
                                                        ></div>
                                                        <div 
                                                            className="qc-project-summary-bar qc-bar-inspected" 
                                                            style={{ width: `${project.qcStatistics.total.percentInspected}%` }}
                                                            title={`Passed: ${project.qcStatistics.total.inspected}/${project.qcStatistics.total.total} (${Math.round(project.qcStatistics.total.percentInspected)}%)`}
                                                        ></div>
                                                        {project.qcStatistics.total.failures > 0 && (
                                                            <div 
                                                                className="qc-project-summary-bar qc-bar-failures" 
                                                                style={{ width: `${project.qcStatistics.total.total > 0 ? (project.qcStatistics.total.failures / project.qcStatistics.total.total) * 100 : 0}%` }}
                                                                title={`Failed: ${project.qcStatistics.total.failures}/${project.qcStatistics.total.total}`}
                                                            ></div>
                                                        )}
                                                    </div>
                                                    <div className="qc-project-summary-total">{project.qcStatistics.total.total}</div>
                                                </div>
                                            </div>
                                        )}
                                        {/* Individual category statistics - only on hover */}
                                        {hoveredProject === (project.project_number || index) && (
                                            <>
                                                {Object.entries(project.qcStatistics)
                                                    .filter(([key, value]) => typeof value === 'object' && value.displayName && key !== 'total')
                                                    .map(([categoryKey, stats]) => (
                                                        <div key={categoryKey} className="qc-project-summary-category">
                                                            <div className="qc-project-summary-category-name">{stats.displayName}</div>
                                                            <div className="qc-project-summary-bars">
                                                                <div className="qc-project-summary-bar-container">
                                                                    <div 
                                                                        className="qc-project-summary-bar qc-bar-onsite" 
                                                                        style={{ width: `${stats.percentOnsite}%` }}
                                                                        title={`Onsite: ${stats.onsite}/${stats.total} (${Math.round(stats.percentOnsite)}%)`}
                                                                    ></div>
                                                                    <div 
                                                                        className="qc-project-summary-bar qc-bar-installed" 
                                                                        style={{ width: `${stats.percentInstalled}%` }}
                                                                        title={`Installed: ${stats.installed}/${stats.total} (${Math.round(stats.percentInstalled)}%)`}
                                                                    ></div>
                                                                    <div 
                                                                        className="qc-project-summary-bar qc-bar-inspected" 
                                                                        style={{ width: `${stats.percentInspected}%` }}
                                                                        title={`Passed: ${stats.inspected}/${stats.total} (${Math.round(stats.percentInspected)}%)`}
                                                                    ></div>
                                                                    {stats.failures > 0 && (
                                                                        <div 
                                                                            className="qc-project-summary-bar qc-bar-failures" 
                                                                            style={{ width: `${stats.total > 0 ? (stats.failures / stats.total) * 100 : 0}%` }}
                                                                            title={`Failed: ${stats.failures}/${stats.total}`}
                                                                        ></div>
                                                                    )}
                                                                </div>
                                                                <div className="qc-project-summary-total">{stats.total}</div>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            ))}
                        </div>
                    )}
                </div>
                );
            })}
        </div>
    );

};

const QualityControlHeader = ({apiToken, search, setSearch, branchFilters, setBranchFilters, availableBranches, refreshProjectsList,generateCompleteReport, timestamp, projectFilters, setProjectFilters, allProjects, reportFilename, reportError}) => {
    const [showBranchDropdown, setShowBranchDropdown] = useState(false);
    const [showProjectDropdown, setShowProjectDropdown] = useState(false);

    const handleOpenHelp = () => {
        if (helpURL) {
            window.open(helpURL, '_blank', 'noopener,noreferrer');
        }
    };

    const formatTimestamp = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const toggleBranchFilter = (branch) => {
        setBranchFilters(prev => {
            if (prev.includes(branch)) {
                return prev.filter(b => b !== branch);
            } else {
                return [...prev, branch];
            }
        });
    };

    const toggleProjectFilter = (projectNumber) => {
        setProjectFilters(prev => {
            if (prev.includes(projectNumber)) {
                return prev.filter(p => p !== projectNumber);
            } else {
                return [...prev, projectNumber];
            }
        });
    };

    // Get available projects based on branch filter
    const getAvailableProjects = () => {
        if (!allProjects) return [];
        
        let projectsList = [];
        const branchesToShow = branchFilters.length > 0 ? branchFilters : availableBranches;
        
        branchesToShow.forEach(branch => {
            if (allProjects[branch]) {
                allProjects[branch].forEach(project => {
                    projectsList.push({
                        ...project,
                        branch: branch
                    });
                });
            }
        });
        
        return projectsList.sort((a, b) => a.displayName.localeCompare(b.displayName));
    };

    const availableProjects = getAvailableProjects();

    const clearAllFilters = () => {
        setSearch('');
        setBranchFilters([]);
        setProjectFilters([]);
    };

    const hasFilters = search || branchFilters.length > 0 || projectFilters.length > 0;

    return(
        <div className="quality-control-header">
            <div className="quality-control-header-search">
                <input 
                    type="text" 
                    className="quality-control-header-search-input" 
                    placeholder="Search Projects..." 
                    value={search}
                    onChange={(e) => setSearch(e.target.value)} 
                />
                {hasFilters && (
                    <button 
                        className="quality-control-clear-filters-btn"
                        onClick={clearAllFilters}
                        title="Clear all filters"
                    >
                        Clear Filters
                    </button>
                )}
            </div>
            <div className="quality-control-header-filters">
                <div className="quality-control-branch-dropdown-container">
                    <button
                        className="quality-control-branch-dropdown-btn"
                        onClick={() => setShowBranchDropdown(!showBranchDropdown)}
                    >
                        {branchFilters.length === 0 ? 'All Branches' : 
                         branchFilters.length === 1 ? `${branchFilters[0]} - ${branchList[branchFilters[0]]?.name || ''}` :
                         `${branchFilters.length} Branches Selected`}
                        <span className="dropdown-arrow">{showBranchDropdown ? '▲' : '▼'}</span>
                    </button>
                    {showBranchDropdown && (
                        <div className="quality-control-branch-dropdown-menu">
                            {availableBranches.map(branch => (
                                <label key={branch} className="quality-control-branch-dropdown-item">
                                    <input
                                        type="checkbox"
                                        checked={branchFilters.includes(branch)}
                                        onChange={() => toggleBranchFilter(branch)}
                                    />
                                    <span>{branch} - {branchList[branch]?.name || ''}</span>
                                </label>
                            ))}
                        </div>
                    )}
                </div>
                <div className="quality-control-branch-dropdown-container">
                    <button
                        className="quality-control-branch-dropdown-btn"
                        onClick={() => setShowProjectDropdown(!showProjectDropdown)}
                    >
                        {projectFilters.length === 0 ? 'All Projects' : 
                         projectFilters.length === 1 ? availableProjects.find(p => p.project_number === projectFilters[0])?.displayName || 'Project' :
                         `${projectFilters.length} Projects Selected`}
                        <span className="dropdown-arrow">{showProjectDropdown ? '▲' : '▼'}</span>
                    </button>
                    {showProjectDropdown && (
                        <div className="quality-control-branch-dropdown-menu">
                            {availableProjects.length > 0 ? (
                                availableProjects.map(project => (
                                    <label key={project.project_number} className="quality-control-branch-dropdown-item">
                                        <input
                                            type="checkbox"
                                            checked={projectFilters.includes(project.project_number)}
                                            onChange={() => toggleProjectFilter(project.project_number)}
                                        />
                                        <span>{project.displayName}</span>
                                    </label>
                                ))
                            ) : (
                                <div className="quality-control-branch-dropdown-item" style={{color: '#999', cursor: 'default'}}>
                                    No projects available
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            {   reportFilename ?
                <button
                    className="quality-control-report-btn"
                    onClick={() => downloadCompleteQCReport(apiToken, reportFilename)}
                    title="Download Complete Report"
                >
                    Download Report
                </button>
                :
                <button
                    className="quality-control-report-btn"
                    onClick={generateCompleteReport}
                    title="Generate Complete Report"
                >
                    Generate Report
                </button>
            }

            {timestamp && (
                <div className="quality-control-timestamp">
                    {formatTimestamp(timestamp)}
                </div>
            )}
            <button
                className="quality-control-refresh-btn"
                onClick={refreshProjectsList}
                title="Refresh projects list"
            >
                ↻
            </button>
            <button
                className="quality-control-help-btn"
                onClick={handleOpenHelp}
                title="Open help"
            >
                ?
            </button>
        </div>
    )
};

// Memoized single QC table row. Only re-renders when this specific row's data
// changes, so editing/typing in one row does not re-render thousands of others.
const QCTableRow = React.memo(({
    sectionName,
    item,
    displayIndex,
    originalIndex,
    orderedFieldKeys,
    categoryFields,
    requiredFieldLeftOffsets,
    manualEdit,
    isEdited,
    dateInputs,
    issueStatus,
    handleManualFieldChange,
    handleDateInputChange,
    clearDateInputValue,
    openIssueModal
}) => {
    const getFieldValue = (fieldKey) => {
        if (manualEdit && manualEdit.changes[fieldKey] !== undefined) {
            return manualEdit.changes[fieldKey];
        }
        return item[fieldKey] || '';
    };

    const getDateInputValue = (fieldKey) => {
        const inputKey = `${sectionName}-${originalIndex}-${fieldKey}`;
        if (dateInputs[inputKey] !== undefined) {
            return dateInputs[inputKey];
        }
        return formatDateToDisplay(getFieldValue(fieldKey));
    };

    const issueCount = issueStatus.issues.length;
    const isDeletedRow = getFieldValue('scope') === 'Deleted';

    return (
        <tr className="qc-table-row">
            <td
                className="qc-table-cell qc-table-status-indicator"
                style={{
                    backgroundColor: getRowStatusColor(item, categoryFields),
                    width: '5px',
                    padding: 0,
                    border: 'none'
                }}
            ></td>
            <td className="qc-table-cell qc-table-row-number qc-table-frozen">
                {displayIndex + 1}
            </td>
            {orderedFieldKeys.map((fieldKey) => {
                const fieldConfig = categoryFields[fieldKey];
                const isRequired = fieldConfig.requiredToCreate;
                const frozenClass = isRequired ? 'qc-table-frozen' : '';
                const isDate = fieldConfig.type === 'date';
                const isTextarea = categoryFields[fieldKey].type === 'textArea';
                const isManualEntry = fieldConfig.manualEntry;
                const isDeleted = isDeletedRow;

                let displayValue = '';
                let cssClass = '';
                if (fieldConfig.type === 'inspection') {
                    const inspectionResult = getInspectionSymbol(item[fieldKey]);
                    displayValue = inspectionResult.symbol;
                    cssClass = inspectionResult.class;
                } else if (item[fieldKey] !== undefined && item[fieldKey] !== null) {
                    displayValue = item[fieldKey].toString();
                }

                return (
                    <td
                        key={fieldKey}
                        className={`qc-table-cell ${fieldConfig.type === 'inspection' ? 'qc-table-inspection' : ''} ${isDate ? 'qc-table-date-cell' : ''} ${isTextarea ? 'qc-table-textarea-cell' : ''} ${frozenClass}`}
                        style={{
                            ...(isRequired ? { left: requiredFieldLeftOffsets[fieldKey] } : {}),
                            ...(isDeleted ? { textDecoration: 'line-through', opacity: 0.6 } : {})
                        }}
                    >
                        {isManualEntry ? (
                            isDate ? (
                                <input
                                    type="text"
                                    value={getDateInputValue(fieldKey)}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if (inputValue === '' || /^[\d\/]*$/.test(inputValue)) {
                                            handleDateInputChange(sectionName, originalIndex, fieldKey, inputValue);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        const parsedDate = parseDateFromPaste(e.target.value);
                                        if (parsedDate) {
                                            handleManualFieldChange(sectionName, originalIndex, fieldKey, parsedDate);
                                        } else if (e.target.value === '') {
                                            handleManualFieldChange(sectionName, originalIndex, fieldKey, '');
                                        }
                                        clearDateInputValue(sectionName, originalIndex, fieldKey);
                                    }}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        const pastedText = e.clipboardData.getData('text');
                                        const parsedDate = parseDateFromPaste(pastedText);
                                        if (parsedDate) {
                                            handleManualFieldChange(sectionName, originalIndex, fieldKey, parsedDate);
                                        }
                                    }}
                                    placeholder="MM/DD/YY"
                                    style={{
                                        width: '100%',
                                        border: 'none',
                                        padding: '4px',
                                        fontSize: '13px',
                                        background: isEdited ? '#e8f5e9' : 'transparent',
                                        outline: 'none',
                                        cursor: 'text',
                                        ...(isDeleted ? { textDecoration: 'line-through' } : {})
                                    }}
                                />
                            ) : (
                                <input
                                    type="text"
                                    value={getFieldValue(fieldKey)}
                                    onChange={(e) => handleManualFieldChange(sectionName, originalIndex, fieldKey, e.target.value)}
                                    style={{
                                        width: '100%',
                                        border: 'none',
                                        padding: '4px',
                                        fontSize: '13px',
                                        background: isEdited ? '#e8f5e9' : 'transparent',
                                        outline: 'none',
                                        ...(isDeleted ? { textDecoration: 'line-through' } : {})
                                    }}
                                />
                            )
                        ) : (
                            fieldConfig.type === 'inspection' && displayValue ? (
                                <span className={`qc-table-inspection-symbol ${cssClass}`} style={isDeleted ? { textDecoration: 'line-through' } : {}}>
                                    {displayValue}
                                </span>
                            ) : (
                                <span style={isDeleted ? { textDecoration: 'line-through' } : {}}>
                                    {isDate ? formatDateToDisplay(displayValue) : displayValue}
                                </span>
                            )
                        )}
                    </td>
                );
            })}
            <td className="qc-table-cell" style={{ width: '120px' }}>
                {item.lastModifiedBy || ''}
            </td>
            <td className="qc-table-cell" style={{ width: '100px' }}>
                {item.lastModifiedDate ? formatDateToDisplay(item.lastModifiedDate) : ''}
            </td>
            <td className="qc-table-cell qc-table-issues-cell">
                {issueStatus.status && (
                    <button
                        type="button"
                        className={`qc-issue-indicator ${issueStatus.status}`}
                        onClick={() => openIssueModal(sectionName, displayIndex, item)}
                        title={issueStatus.status === 'warning'
                            ? `${issueCount} unresolved issue${issueCount > 1 ? 's' : ''}`
                            : `${issueCount} resolved issue${issueCount > 1 ? 's' : ''}`
                        }
                    >
                        ⚠
                    </button>
                )}
            </td>
            <td className="qc-table-cell" style={{ width: '40px', textAlign: 'center', padding: '4px' }}>
                <button
                    onClick={() => {
                        const currentScope = getFieldValue('scope');
                        const newScope = currentScope === 'Deleted' ? 'Original' : 'Deleted';
                        handleManualFieldChange(sectionName, originalIndex, 'scope', newScope);
                    }}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '16px',
                        padding: '2px',
                        color: isDeletedRow ? '#28a745' : '#dc3545',
                        transition: 'color 0.2s ease'
                    }}
                    title={isDeletedRow ? 'Restore item' : 'Delete item'}
                >
                    {isDeletedRow ? '↶' : '🗑️'}
                </button>
            </td>
        </tr>
    );
}, (prev, next) => {
    // Custom comparator: skip re-render unless this row's relevant data changed.
    if (
        prev.item !== next.item ||
        prev.manualEdit !== next.manualEdit ||
        prev.isEdited !== next.isEdited ||
        prev.displayIndex !== next.displayIndex ||
        prev.originalIndex !== next.originalIndex ||
        prev.sectionName !== next.sectionName ||
        prev.orderedFieldKeys !== next.orderedFieldKeys ||
        prev.categoryFields !== next.categoryFields ||
        prev.requiredFieldLeftOffsets !== next.requiredFieldLeftOffsets ||
        prev.handleManualFieldChange !== next.handleManualFieldChange ||
        prev.handleDateInputChange !== next.handleDateInputChange ||
        prev.clearDateInputValue !== next.clearDateInputValue ||
        prev.openIssueModal !== next.openIssueModal
    ) {
        return false;
    }

    // Compare issue status (status string + issue count)
    const prevIssues = prev.issueStatus;
    const nextIssues = next.issueStatus;
    if (prevIssues.status !== nextIssues.status || prevIssues.issues.length !== nextIssues.issues.length) {
        return false;
    }

    // Compare only the date-input values that belong to this row
    if (prev.dateInputs !== next.dateInputs) {
        for (const fieldKey of next.orderedFieldKeys) {
            const inputKey = `${next.sectionName}-${next.originalIndex}-${fieldKey}`;
            if (prev.dateInputs[inputKey] !== next.dateInputs[inputKey]) {
                return false;
            }
        }
    }

    return true;
});

const ProjectDetails = React.memo(({apiToken,activeUser,selectedProject,closeProjectDetails,submitQCLists,updateProjectQCList,updateProjectStats,qcCategories,refreshSelectedProjectData,showRefreshNotification,
    submitInitializedFile,submitInitializedObject, issueLogs, issueLogsError }) => {
    const [ addingItems, setAddingItems ] = useState(false);

    const [ initializing, setInitializing ] = useState(false);
    const [ initializedFile, setInitializedFile ] = useState(null);
    const [ submittingInitialized, setSubmittingInitialized ] = useState(false);
    const [ initializedError, setInitializedError ] = useState(null);
    const [ initializedObject, setInitializedObject ] = useState(null);
    const [ deleteNotFound, setDeleteNotFound ] = useState(false);

    const [ projectReportFilename, setProjectReportFilename ] = useState(null);

    const [ selectedCategories, setSelectedCategories ] = useState({});
    const [ scopeDefaults, setScopeDefaults ] = useState({});
    const [ importDocument, setImportDocument ] = useState(null);
    const [ importedQCList, setImportedQCList ] = useState(null);
    const [ importingFile, setImportingFile ] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState(null);
    const [ qcSearchText, setQcSearchText ] = useState('');
    const [ searchInputValue, setSearchInputValue ] = useState('');
    const [ copiedLink, setCopiedLink ] = useState(null);
    const [ showSharedLinks, setShowSharedLinks ] = useState(false);
    const [ manualEdits, setManualEdits ] = useState({});
    const [ editedItems, setEditedItems ] = useState(new Set());
    const [ dateInputs, setDateInputs ] = useState({});
    const [ activeFilter, setActiveFilter ] = useState(null);
    const [ scopeFilter, setScopeFilter ] = useState('all');
    const [ showScopeDropdown, setShowScopeDropdown ] = useState(false);
    const [ collapsedTypeBreakouts, setCollapsedTypeBreakouts ] = useState({});
    const [ collapsedOpeningBreakouts, setCollapsedOpeningBreakouts ] = useState({});
    const [ isProjectSummaryCollapsed, setIsProjectSummaryCollapsed ] = useState(false);
    const [ isSummaryByAreaCollapsed, setIsSummaryByAreaCollapsed ] = useState(true);
    const [ showImportUpdateModal, setShowImportUpdateModal ] = useState(false);
    const [ importUpdatePIN, setImportUpdatePIN ] = useState('');
    const [ importUpdatePINError, setImportUpdatePINError ] = useState(false);
    const [ importUpdatePINVerified, setImportUpdatePINVerified ] = useState(false);
    const [ importUpdateFile, setImportUpdateFile ] = useState(null);
    const [ importUpdateProcessing, setImportUpdateProcessing ] = useState(false);
    const [ importUpdateSuccess, setImportUpdateSuccess ] = useState(false);
    const [ importUpdateFailure, setImportUpdateFailure ] = useState(false);
    const [ selectedIssueRow, setSelectedIssueRow ] = useState(null);
    const [ sectionPages, setSectionPages ] = useState({});
    const contentWrapperRef = useRef(null);

    // Number of QC rows to render per page for each section
    const QC_PAGE_SIZE = 100;

    const issueLogsByTypeAndReference = useMemo(() => {
        const groupedIssues = {};

        if (!Array.isArray(issueLogs)) {
            return groupedIssues;
        }

        issueLogs.forEach((issueLog) => {
            const normalizedType = normalizeIssueType(issueLog?.type);
            const normalizedReference = normalizeReferenceId(issueLog?.referenceId);

            if (!normalizedType || normalizedReference === null) {
                return;
            }

            const groupKey = `${normalizedType}-${normalizedReference}`;
            if (!groupedIssues[groupKey]) {
                groupedIssues[groupKey] = [];
            }
            groupedIssues[groupKey].push(issueLog);
        });

        return groupedIssues;
    }, [issueLogs]);

    // Debounce search input to reduce expensive filtering operations
    useEffect(() => {
        const timer = setTimeout(() => {
            setQcSearchText(searchInputValue);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchInputValue]);

    // Reset pagination to the first page whenever the filtered result set changes
    useEffect(() => {
        setSectionPages({});
    }, [activeFilter, scopeFilter, qcSearchText]);

    // Initialize all type breakouts as collapsed when project statistics are loaded
    useEffect(() => {
        if (selectedProject?.qcStatistics) {
            const initialCollapsedState = {};
            const initialOpeningCollapsedState = {};
            Object.keys(selectedProject.qcStatistics).forEach(categoryKey => {
                if (categoryKey !== 'total' && selectedProject.qcStatistics[categoryKey]?.typeBreakout) {
                    initialCollapsedState[categoryKey] = true;
                }
                if (categoryKey !== 'total' && selectedProject.qcStatistics[categoryKey]?.openingStats) {
                    initialOpeningCollapsedState[categoryKey] = true;
                }
            });
            setCollapsedTypeBreakouts(initialCollapsedState);
            setCollapsedOpeningBreakouts(initialOpeningCollapsedState);
        }
    }, [selectedProject?.qcStatistics]);

    const getNonEmptySections = useMemo(() => {
        if (!selectedProject?.qcList) return [];
        
        return Object.entries(selectedProject.qcList)
            .filter(([key, value]) => Array.isArray(value) && value.length > 0)
            .map(([key, value]) => ({
                name: key,
                items: value
            }));
    }, [selectedProject?.qcList]);

    // Precompute stable per-category table metadata (field ordering, column widths,
    // frozen-column offsets). Computed once per qcCategories change so that the
    // memoized QCTableRow receives referentially-stable props and can skip renders.
    const sectionMetadata = useMemo(() => {
        const metadata = {};
        const getFieldColumnWidth = (fieldConfig) => {
            if (fieldConfig.type === 'inspection') return '32px';
            if (fieldConfig.type === 'date') return '100px';
            if (fieldConfig.type === 'textArea') return '500px';
            return '120px';
        };

        Object.entries(qcCategories || {}).forEach(([categoryKey, categoryConfig]) => {
            const categoryFields = categoryConfig?.fields || {};
            const fieldKeys = Object.keys(categoryFields);
            const requiredFieldKeys = fieldKeys.filter(key => categoryFields[key].requiredToCreate);
            const optionalFieldKeys = fieldKeys.filter(key => !categoryFields[key].requiredToCreate);
            const orderedFieldKeys = [...requiredFieldKeys, ...optionalFieldKeys];

            const columnDefinitions = [
                { key: 'status-indicator', width: '5px' },
                { key: 'row-number', width: '50px' },
                ...orderedFieldKeys.map((fieldKey) => ({
                    key: `field-${fieldKey}`,
                    width: getFieldColumnWidth(categoryFields[fieldKey])
                })),
                { key: 'last-modified-by', width: '120px' },
                { key: 'last-modified-date', width: '100px' },
                { key: 'issues', width: '70px' },
                { key: 'delete', width: '40px' }
            ];

            const requiredFieldLeftOffsets = {};
            let currentRequiredOffset = 55;
            orderedFieldKeys.forEach((fieldKey) => {
                const fieldConfig = categoryFields[fieldKey];
                if (fieldConfig?.requiredToCreate) {
                    requiredFieldLeftOffsets[fieldKey] = `${currentRequiredOffset}px`;
                    currentRequiredOffset += parseInt(getFieldColumnWidth(fieldConfig), 10) || 120;
                }
            });

            metadata[categoryKey] = {
                categoryFields,
                orderedFieldKeys,
                requiredFieldKeys,
                columnDefinitions,
                requiredFieldLeftOffsets,
                getFieldColumnWidth
            };
        });

        return metadata;
    }, [qcCategories]);

    const getFilteredSections = useMemo(() => {
        const sections = getNonEmptySections;
        
        // If there's an active filter, handle it
        if (activeFilter) {
            // Check if this is a type breakout filter (format: "categoryKey-typeKey")
            const isTypeBreakoutFilter = activeFilter.parentCategory && activeFilter.typeKey;
            
            // For type breakout filters, we need to filter by both category and type
            if (isTypeBreakoutFilter) {
                const filteredSections = sections.filter(section => section.name === activeFilter.parentCategory);
                
                return filteredSections.map(section => {
                    const categoryFields = qcCategories[section.name]?.fields || {};
                    const requiredFieldKeys = Object.keys(categoryFields).filter(
                        key => categoryFields[key].requiredToCreate
                    );
                    const inspectionFields = Object.keys(categoryFields).filter(
                        key => categoryFields[key].type === 'inspection'
                    );
                    
                    // Map items with their original indices
                    let filteredItems = section.items.map((item, originalIndex) => ({
                        ...item,
                        _originalIndex: originalIndex
                    }));

                    if (activeFilter?.area) {
                        filteredItems = filteredItems.filter(item => itemMatchesArea(item, activeFilter.area));
                    }
                    
                    if(activeFilter.parentCategory === 'ceiling'){
                        filteredItems = filteredItems.filter(item => item.ceilingType === activeFilter.typeKey);
                    }
                    else {
                        filteredItems = filteredItems.filter(item => item.type === activeFilter.typeKey);
                    };
                    
                    
                    // Apply scope filter
                    if (scopeFilter !== 'all') {
                        filteredItems = filteredItems.filter(item => item.scope === scopeFilter);
                    }
                    
                    // Apply search filter
                    if (qcSearchText && qcSearchText.trim() !== '') {
                        const searchLower = qcSearchText.toLowerCase();
                        filteredItems = filteredItems.filter(item => {
                            return requiredFieldKeys.some(fieldKey => {
                                const fieldValue = item[fieldKey];
                                if (fieldValue === null || fieldValue === undefined) return false;
                                return fieldValue.toString().toLowerCase().includes(searchLower);
                            });
                        });
                    }
                    
                    // Apply progress bar filter if specified
                    if (activeFilter.filterType) {
                        filteredItems = filteredItems.filter(item => {
                            const hasReceivedDate = item.receivedDate && item.receivedDate.toString().trim() !== '';
                            const hasInstallDate = item.installDate && item.installDate.toString().trim() !== '';
                            
                            const inspectionValues = inspectionFields
                                .map(field => item[field])
                                .filter(value => value !== undefined && value !== null && value !== '');
                            
                            const hasFail = inspectionValues.some(value => value === 'fail');
                            const hasAnyInspection = inspectionValues.length > 0;
                            const allComplete = inspectionFields.length > 0 && 
                                inspectionFields.every(field => {
                                    const value = item[field];
                                    return value === 'pass' || value === 'N/A';
                                });
                            
                            let matches = false;
                            switch (activeFilter.filterType) {
                                case 'onsite':
                                    matches = hasReceivedDate;
                                    break;
                                case 'installed':
                                    matches = hasInstallDate;
                                    break;
                                case 'activeInspections':
                                    matches = hasInstallDate && hasAnyInspection && !allComplete && !hasFail;
                                    break;
                                case 'inspected':
                                    matches = allComplete;
                                    break;
                                case 'failures':
                                    matches = hasFail;
                                    break;
                                default:
                                    matches = true;
                            }
                            
                            return activeFilter.inverted ? !matches : matches;
                        });
                    }
                    
                    return {
                        name: section.name,
                        items: filteredItems
                    };
                }).filter(section => section.items.length > 0);
            }
            
            // Special handling for "total" category - show all categories but filter items
            if (activeFilter.category === 'total') {
                return sections.map(section => {
                    const categoryFields = qcCategories[section.name]?.fields || {};
                    const requiredFieldKeys = Object.keys(categoryFields).filter(
                        key => categoryFields[key].requiredToCreate
                    );
                    const inspectionFields = Object.keys(categoryFields).filter(
                        key => categoryFields[key].type === 'inspection'
                    );
                    
                    // Map items with their original indices
                    let filteredItems = section.items.map((item, originalIndex) => ({
                        ...item,
                        _originalIndex: originalIndex
                    }));

                    if (activeFilter?.area) {
                        filteredItems = filteredItems.filter(item => itemMatchesArea(item, activeFilter.area));
                    }
                    
                    // Apply scope filter
                    if (scopeFilter !== 'all') {
                        filteredItems = filteredItems.filter(item => item.scope === scopeFilter);
                    }
                    
                    // Apply search filter
                    if (qcSearchText && qcSearchText.trim() !== '') {
                        const searchLower = qcSearchText.toLowerCase();
                        filteredItems = filteredItems.filter(item => {
                            return requiredFieldKeys.some(fieldKey => {
                                const fieldValue = item[fieldKey];
                                if (fieldValue === null || fieldValue === undefined) return false;
                                return fieldValue.toString().toLowerCase().includes(searchLower);
                            });
                        });
                    }
                    
                    // Apply progress bar filter for total category
                    if (activeFilter.filterType) {
                        filteredItems = filteredItems.filter(item => {
                            const hasReceivedDate = item.receivedDate && item.receivedDate.toString().trim() !== '';
                            const hasInstallDate = item.installDate && item.installDate.toString().trim() !== '';
                            
                            const inspectionValues = inspectionFields
                                .map(field => item[field])
                                .filter(value => value !== undefined && value !== null && value !== '');
                            
                            const hasFail = inspectionValues.some(value => value === 'fail');
                            const hasAnyInspection = inspectionValues.length > 0;
                            const allComplete = inspectionFields.length > 0 && 
                                inspectionFields.every(field => {
                                    const value = item[field];
                                    return value === 'pass' || value === 'N/A';
                                });
                            
                            let matches = false;
                            switch (activeFilter.filterType) {
                                case 'onsite':
                                    matches = hasReceivedDate;
                                    break;
                                case 'installed':
                                    matches = hasInstallDate;
                                    break;
                                case 'activeInspections':
                                    matches = hasInstallDate && hasAnyInspection && !allComplete && !hasFail;
                                    break;
                                case 'inspected':
                                    matches = allComplete;
                                    break;
                                case 'failures':
                                    matches = hasFail;
                                    break;
                                default:
                                    matches = true;
                            }
                            
                            // Invert the result if inverted flag is set
                            return activeFilter.inverted ? !matches : matches;
                        });
                    }
                    
                    return {
                        name: section.name,
                        items: filteredItems
                    };
                }).filter(section => section.items.length > 0);
            }
            
            // Regular category filter (existing logic)
            const filteredSections = sections.filter(section => section.name === activeFilter.category);
            
            return filteredSections.map(section => {
                const categoryFields = qcCategories[section.name]?.fields || {};
                const requiredFieldKeys = Object.keys(categoryFields).filter(
                    key => categoryFields[key].requiredToCreate
                );
                const inspectionFields = Object.keys(categoryFields).filter(
                    key => categoryFields[key].type === 'inspection'
                );
                
                // Map items with their original indices
                let filteredItems = section.items.map((item, originalIndex) => ({
                    ...item,
                    _originalIndex: originalIndex
                }));

                if (activeFilter?.area) {
                    filteredItems = filteredItems.filter(item => itemMatchesArea(item, activeFilter.area));
                }
                
                // Apply scope filter
                if (scopeFilter !== 'all') {
                    filteredItems = filteredItems.filter(item => item.scope === scopeFilter);
                }
                
                // Apply search filter
                if (qcSearchText && qcSearchText.trim() !== '') {
                    const searchLower = qcSearchText.toLowerCase();
                    filteredItems = filteredItems.filter(item => {
                        return requiredFieldKeys.some(fieldKey => {
                            const fieldValue = item[fieldKey];
                            if (fieldValue === null || fieldValue === undefined) return false;
                            return fieldValue.toString().toLowerCase().includes(searchLower);
                        });
                    });
                }
                
                // Apply progress bar filter only if filterType is specified
                if (activeFilter.filterType) {
                    filteredItems = filteredItems.filter(item => {
                        const hasReceivedDate = item.receivedDate && item.receivedDate.toString().trim() !== '';
                        const hasInstallDate = item.installDate && item.installDate.toString().trim() !== '';
                        
                        const inspectionValues = inspectionFields
                            .map(field => item[field])
                            .filter(value => value !== undefined && value !== null && value !== '');
                        
                        const hasFail = inspectionValues.some(value => value === 'fail');
                        const hasAnyInspection = inspectionValues.length > 0;
                        const allComplete = inspectionFields.length > 0 && 
                            inspectionFields.every(field => {
                                const value = item[field];
                                return value === 'pass' || value === 'N/A';
                            });
                        
                        let matches = false;
                        switch (activeFilter.filterType) {
                            case 'onsite':
                                matches = hasReceivedDate;
                                break;
                            case 'installed':
                                matches = hasInstallDate;
                                break;
                            case 'activeInspections':
                                matches = hasInstallDate && hasAnyInspection && !allComplete && !hasFail;
                                break;
                            case 'inspected':
                                matches = allComplete;
                                break;
                            case 'failures':
                                matches = hasFail;
                                break;
                            default:
                                matches = true;
                        }
                        
                        // Invert the result if inverted flag is set
                        return activeFilter.inverted ? !matches : matches;
                    });
                }
                
                return {
                    name: section.name,
                    items: filteredItems
                };
            }).filter(section => section.items.length > 0);
        }
        
        // No active filter - apply only search filter and scope filter
        return sections.map(section => {
            const categoryFields = qcCategories[section.name]?.fields || {};
            const requiredFieldKeys = Object.keys(categoryFields).filter(
                key => categoryFields[key].requiredToCreate
            );
            
            // Map items with their original indices
            let filteredItems = section.items.map((item, originalIndex) => ({
                ...item,
                _originalIndex: originalIndex
            }));
            
            // Apply scope filter
            if (scopeFilter !== 'all') {
                filteredItems = filteredItems.filter(item => item.scope === scopeFilter);
            }
            
            // Apply search filter
            if (qcSearchText && qcSearchText.trim() !== '') {
                const searchLower = qcSearchText.toLowerCase();
                filteredItems = filteredItems.filter(item => {
                    return requiredFieldKeys.some(fieldKey => {
                        const fieldValue = item[fieldKey];
                        if (fieldValue === null || fieldValue === undefined) return false;
                        return fieldValue.toString().toLowerCase().includes(searchLower);
                    });
                });
            }
            
            return {
                name: section.name,
                items: filteredItems
            };
        }).filter(section => section.items.length > 0);
    }, [getNonEmptySections, activeFilter, scopeFilter, qcSearchText, qcCategories]);

    const closeAddingItems = useCallback(() => {setAddingItems(false);setSelectedCategories({});setScopeDefaults({});}, []);
    
    const handleProgressBarClick = useCallback((categoryKey, filterType) => {
        // Cycle through: normal -> inverted -> cleared
        if (activeFilter?.category === categoryKey && activeFilter?.filterType === filterType) {
            if (activeFilter?.inverted) {
                // Third click - clear the filter
                setActiveFilter(null);
            } else {
                // Second click - invert the filter
                setActiveFilter({ category: categoryKey, filterType, inverted: true });
            }
        } else {
            // First click - set normal filter
            setActiveFilter({ category: categoryKey, filterType, inverted: false });
        }
    }, [activeFilter]);
    
    const handleCategoryHeaderClick = useCallback((categoryKey) => {
        // Toggle category filter - if clicking the same category, clear it
        if (activeFilter?.category === categoryKey && !activeFilter?.filterType) {
            setActiveFilter(null);
        } else {
            setActiveFilter({ category: categoryKey, filterType: null });
        }
    }, [activeFilter]);

    const handleAreaHeaderClick = useCallback((areaName) => {
        if (
            activeFilter?.area === areaName &&
            activeFilter?.category === 'total' &&
            !activeFilter?.filterType
        ) {
            setActiveFilter(null);
        } else {
            setActiveFilter({ category: 'total', filterType: null, area: areaName });
        }
    }, [activeFilter]);

    const handleAreaCategoryHeaderClick = useCallback((areaName, categoryKey) => {
        if (
            activeFilter?.area === areaName &&
            activeFilter?.category === categoryKey &&
            !activeFilter?.filterType
        ) {
            setActiveFilter(null);
        } else {
            setActiveFilter({ category: categoryKey, filterType: null, area: areaName });
        }
    }, [activeFilter]);

    const handleAreaProgressBarClick = useCallback((areaName, categoryKey, filterType) => {
        if (
            activeFilter?.area === areaName &&
            activeFilter?.category === categoryKey &&
            activeFilter?.filterType === filterType
        ) {
            if (activeFilter?.inverted) {
                setActiveFilter(null);
            } else {
                setActiveFilter({ category: categoryKey, filterType, inverted: true, area: areaName });
            }
        } else {
            setActiveFilter({ category: categoryKey, filterType, inverted: false, area: areaName });
        }
    }, [activeFilter]);

    const toggleTypeBreakout = useCallback((categoryKey) => {
        setCollapsedTypeBreakouts(prev => ({
            ...prev,
            [categoryKey]: !prev[categoryKey]
        }));
    }, []);

    const toggleOpeningBreakout = useCallback((categoryKey) => {
        setCollapsedOpeningBreakouts(prev => ({
            ...prev,
            [categoryKey]: !prev[categoryKey]
        }));
    }, []);

    const handleSectionPageChange = useCallback((sectionName, page) => {
        setSectionPages(prev => ({
            ...prev,
            [sectionName]: page
        }));
        // Scroll the content wrapper back to the top for the new page
        if (contentWrapperRef.current) {
            contentWrapperRef.current.scrollTop = 0;
        }
    }, []);

    const handleImportUpdateClick = useCallback(() => {
        setShowImportUpdateModal(true);
        setImportUpdatePIN('');
        setImportUpdatePINError(false);
        setImportUpdatePINVerified(false);
        setImportUpdateFile(null);
    }, []);

    const handleImportUpdatePinDigit = useCallback((digit) => {
        // Clear error state when user starts typing
        if (importUpdatePINError) {
            setImportUpdatePINError(false);
        }
        
        if (importUpdatePIN.length < 4) {
            const newPin = importUpdatePIN + digit;
            setImportUpdatePIN(newPin);
            
            // Auto-submit when 4 digits are entered
            if (newPin.length === 4) {
                setTimeout(() => {
                    if (newPin === '1169') {
                        setImportUpdatePINVerified(true);
                        setImportUpdatePINError(false);
                    } else {
                        setImportUpdatePINError(true);
                        setTimeout(() => {
                            setShowImportUpdateModal(false);
                            setImportUpdatePINError(false);
                            setImportUpdatePIN('');
                        }, 2000);
                    }
                }, 100);
            }
        }
    }, [importUpdatePIN, importUpdatePINError]);

    const handleImportUpdatePinClear = useCallback(() => {
        setImportUpdatePIN('');
        setImportUpdatePINError(false);
    }, []);

    const handleImportUpdateFileSelect = useCallback((e) => {
        setImportUpdateFile(e.target.files[0]);
    }, []);

    const handleImportUpdateClose = useCallback(() => {
        setShowImportUpdateModal(false);
        setImportUpdatePIN('');
        setImportUpdatePINError(false);
        setImportUpdatePINVerified(false);
        setImportUpdateFile(null);
        setImportUpdateProcessing(false);
        setImportUpdateSuccess(false);
        setImportUpdateFailure(false);
    }, []);

    const closeIssueModal = useCallback(() => {
        setSelectedIssueRow(null);
    }, []);

    useEffect(() => {
        if (importUpdateSuccess) {
            setTimeout(() => {
                handleImportUpdateClose();
                setImportUpdateSuccess(false);
                setImportUpdateFailure(false);
                setImportUpdateProcessing(false);
            }, 2000);
        };
    }, [importUpdateSuccess]);

    const handleImportUpdateSubmit = useCallback(() => {
        setImportUpdateProcessing(true);
        importQCListUpdate(apiToken, importUpdateFile, setImportUpdateSuccess, setImportUpdateFailure, setImportUpdateProcessing, selectedProject.project_number, refreshSelectedProjectData);
    }, [importUpdateFile]);

    const handleTypeBreakoutHeaderClick = useCallback((e, categoryKey, typeKey) => {
        // Stop event from bubbling to prevent toggling the collapse
        e.stopPropagation();

        console.log(`Type Breakout Header Clicked: Category=${categoryKey}, Type=${typeKey}`);
        
        // Create a unique filter key for type breakouts
        const filterKey = `${categoryKey}-${typeKey}`;
        
        // Toggle category filter - if clicking the same type header, clear it
        if (activeFilter?.category === filterKey && !activeFilter?.filterType) {
            setActiveFilter(null);
        } else {
            setActiveFilter({ category: filterKey, filterType: null, parentCategory: categoryKey, typeKey });
        }
    }, [activeFilter]);

    const handleTypeBreakoutClick = useCallback((categoryKey, typeKey, filterType) => {
        // Create a unique filter key for type breakouts
        const filterKey = `${categoryKey}-${typeKey}`;
        
        // Cycle through: normal -> inverted -> cleared
        if (activeFilter?.category === filterKey && activeFilter?.filterType === filterType) {
            if (activeFilter?.inverted) {
                // Third click - clear the filter
                setActiveFilter(null);
            } else {
                // Second click - invert the filter
                setActiveFilter({ category: filterKey, filterType, inverted: true, parentCategory: categoryKey, typeKey });
            }
        } else {
            // First click - set normal filter
            setActiveFilter({ category: filterKey, filterType, inverted: false, parentCategory: categoryKey, typeKey });
        }
    }, [activeFilter]);

    const filteredSections = getFilteredSections;



    const getSummaryCategoryDisplayName = useCallback((categoryKey) => {
        const globalCategoryStats = selectedProject?.qcStatistics?.[categoryKey];
        if (globalCategoryStats?.displayName) {
            return globalCategoryStats.displayName;
        }

        return categoryKey
            .split(/[_\-\s]+/)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }, [selectedProject?.qcStatistics]);

    const getSummaryPercent = (stats, percentKey, valueKey) => {
        if (typeof stats?.[percentKey] === 'number') {
            return stats[percentKey];
        }

        const total = Number(stats?.total) || 0;
        const value = Number(stats?.[valueKey]) || 0;
        return total > 0 ? (value / total) * 100 : 0;
    };

    const renderSummaryProgressBars = (stats, areaName = null, categoryKey = null) => {
        const total = Number(stats?.total) || 0;
        const onsite = Number(stats?.onsite) || 0;
        const installed = Number(stats?.installed) || 0;
        const activeInspections = Number(stats?.activeInspections) || 0;
        const inspected = Number(stats?.inspected) || 0;
        const failures = Number(stats?.failures) || 0;
        const isAreaScopedCard = !!areaName && !!categoryKey;

        const percentOnsite = getSummaryPercent(stats, 'percentOnsite', 'onsite');
        const percentInstalled = getSummaryPercent(stats, 'percentInstalled', 'installed');
        const percentActiveInspections = total > 0 ? (activeInspections / total) * 100 : 0;
        const percentInspected = getSummaryPercent(stats, 'percentInspected', 'inspected');
        const percentFailures = total > 0 ? (failures / total) * 100 : 0;

        const getProgressItemStyle = (filterType) => {
            if (!isAreaScopedCard) {
                return { cursor: 'default', opacity: 1 };
            }

            const isSelected =
                activeFilter?.area === areaName &&
                activeFilter?.category === categoryKey &&
                activeFilter?.filterType === filterType;

            return {
                cursor: 'pointer',
                opacity: isSelected ? 1 : (activeFilter ? 0.5 : 1),
                transition: 'opacity 0.2s ease'
            };
        };

        const getProgressLabelSuffix = (filterType) => {
            if (!isAreaScopedCard) {
                return '';
            }

            const isSelected =
                activeFilter?.area === areaName &&
                activeFilter?.category === categoryKey &&
                activeFilter?.filterType === filterType;

            return isSelected ? (activeFilter?.inverted ? ' ✗' : ' ✓') : '';
        };

        const getProgressClickHandler = (filterType) => {
            if (!isAreaScopedCard) {
                return undefined;
            }

            return () => handleAreaProgressBarClick(areaName, categoryKey, filterType);
        };

        return (
            <div className="qc-summary-progress-bars">
                <div className="qc-progress-item" onClick={getProgressClickHandler('onsite')} style={getProgressItemStyle('onsite')}>
                    <div className="qc-progress-label">
                        <span>Onsite{getProgressLabelSuffix('onsite')}</span>
                        <span>{onsite}/{total} ({Math.round(percentOnsite)}%)</span>
                    </div>
                    <div className="qc-progress-bar">
                        <div
                            className="qc-progress-fill qc-onsite"
                            style={{ width: `${percentOnsite}%` }}
                        ></div>
                    </div>
                </div>

                <div className="qc-progress-item" onClick={getProgressClickHandler('installed')} style={getProgressItemStyle('installed')}>
                    <div className="qc-progress-label">
                        <span>Installed{getProgressLabelSuffix('installed')}</span>
                        <span>{installed}/{total} ({Math.round(percentInstalled)}%)</span>
                    </div>
                    <div className="qc-progress-bar">
                        <div
                            className="qc-progress-fill qc-installed"
                            style={{ width: `${percentInstalled}%` }}
                        ></div>
                    </div>
                </div>

                {stats?.activeInspections !== undefined && (
                    <div className="qc-progress-item" onClick={getProgressClickHandler('activeInspections')} style={getProgressItemStyle('activeInspections')}>
                        <div className="qc-progress-label">
                            <span>Active Inspections{getProgressLabelSuffix('activeInspections')}</span>
                            <span>{activeInspections}/{total} ({Math.round(percentActiveInspections)}%)</span>
                        </div>
                        <div className="qc-progress-bar">
                            <div
                                className="qc-progress-fill qc-active-inspections"
                                style={{ width: `${percentActiveInspections}%` }}
                            ></div>
                        </div>
                    </div>
                )}

                <div className="qc-progress-item" onClick={getProgressClickHandler('inspected')} style={getProgressItemStyle('inspected')}>
                    <div className="qc-progress-label">
                        <span>Passed Inspection{getProgressLabelSuffix('inspected')}</span>
                        <span>{inspected}/{total} ({Math.round(percentInspected)}%)</span>
                    </div>
                    <div className="qc-progress-bar">
                        <div
                            className="qc-progress-fill qc-inspected"
                            style={{ width: `${percentInspected}%` }}
                        ></div>
                    </div>
                </div>

                <div className="qc-progress-item" onClick={getProgressClickHandler('failures')} style={getProgressItemStyle('failures')}>
                    <div className="qc-progress-label">
                        <span>Failed Inspections{getProgressLabelSuffix('failures')}</span>
                        <span>{failures}/{total} ({Math.round(percentFailures)}%)</span>
                    </div>
                    <div className="qc-progress-bar">
                        <div
                            className="qc-progress-fill qc-failures"
                            style={{ width: `${percentFailures}%` }}
                        ></div>
                    </div>
                </div>

                {stats?.totalInstalls !== undefined && (
                    <div className="qc-progress-item" onClick={getProgressClickHandler('installed')} style={getProgressItemStyle('installed')}>
                        <div className="qc-progress-label">
                            <span>Total Installs Progress{getProgressLabelSuffix('installed')}</span>
                            <span>{stats.totalCompletedInstalls || 0}/{stats.totalInstalls} ({Math.round(stats.percentTotalInstalls || 0)}%)</span>
                        </div>
                        <div className="qc-progress-bar">
                            <div
                                className="qc-progress-fill qc-installed"
                                style={{ width: `${stats.percentTotalInstalls || 0}%` }}
                            ></div>
                        </div>
                    </div>
                )}

                {stats?.totalInspections !== undefined && (
                    <div className="qc-progress-item" onClick={getProgressClickHandler('inspected')} style={getProgressItemStyle('inspected')}>
                        <div className="qc-progress-label">
                            <span>Total Inspections Progress{getProgressLabelSuffix('inspected')}</span>
                            <span>{stats.totalCompleteInspections || 0}/{stats.totalInspections} ({Math.round(stats.percentTotalInspections || 0)}%)</span>
                        </div>
                        <div className="qc-progress-bar">
                            <div
                                className="qc-progress-fill qc-inspected"
                                style={{ width: `${stats.percentTotalInspections || 0}%` }}
                            ></div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    useEffect(() => {
        // Add the imported QC list to selected categories
        if (importedQCList && typeof importedQCList === 'object') {
            const updatedCategories = { ...selectedCategories };
            
            // Iterate through each category in the imported list
            for (const [categoryKey, items] of Object.entries(importedQCList)) {
                // Verify the category exists in qcCategories
                if (qcCategories[categoryKey] && Array.isArray(items) && items.length > 0) {
                    // If category already exists, append items; otherwise create new
                    if (updatedCategories[categoryKey]) {
                        updatedCategories[categoryKey] = [...updatedCategories[categoryKey], ...items];
                    } else {
                        updatedCategories[categoryKey] = [...items];
                    }
                }
            }
            
            setSelectedCategories(updatedCategories);
        }

        // Clear the imported QC list after processing
        if (importedQCList) {
            setImportedQCList(null);
            setImportDocument(null);
        }
    },[importedQCList]);

    const getValidationErrors = useCallback(() => {
        const errors = [];
        if (Object.keys(selectedCategories).length === 0) return errors;

        for (const [categoryKey, items] of Object.entries(selectedCategories)) {
            const categoryConfig = qcCategories[categoryKey];
            const categoryDisplayName = categoryConfig?.displayName || categoryKey;
            const requiredFields = Object.entries(categoryConfig.fields)
                .filter(([fieldKey, fieldConfig]) => fieldConfig.requiredToCreate)
                .map(([fieldKey, fieldConfig]) => ({
                    fieldKey,
                    fieldLabel: fieldConfig.displayName || fieldConfig.label || fieldKey
                }));

            items.forEach((item, itemIndex) => {
                const missingFields = requiredFields.filter(({ fieldKey }) =>
                    !item[fieldKey] || item[fieldKey].toString().trim() === ''
                );

                if (missingFields.length > 0) {
                    const missingLabels = missingFields.map(({ fieldLabel }) => fieldLabel).join(', ');
                    errors.push(`${categoryDisplayName} - Row ${itemIndex + 1}: missing ${missingLabels}`);
                }
            });
        }

        return errors;
    }, [selectedCategories, qcCategories]);

    const validationErrors = getValidationErrors();

    const hasLineItems = Object.keys(selectedCategories).length > 0;
    const isSubmitEnabled = hasLineItems && validationErrors.length === 0;

    const handleCategoryClick = useCallback((categoryKey) => {
        if (selectedCategories[categoryKey]) {
            // Remove category if already selected
            const updatedCategories = { ...selectedCategories };
            delete updatedCategories[categoryKey];
            setSelectedCategories(updatedCategories);
        } else {
            // Add category with one empty line item with default scope
            const defaultScope = scopeDefaults[categoryKey] || 'Original';
            setSelectedCategories({
                ...selectedCategories,
                [categoryKey]: [{ scope: defaultScope }]
            });
        }
    }, [selectedCategories, scopeDefaults]);

    const handleFieldChange = useCallback((categoryKey, itemIndex, fieldKey, value) => {
        const updatedCategories = { ...selectedCategories };
        const updatedItems = [...updatedCategories[categoryKey]];
        updatedItems[itemIndex] = {
            ...updatedItems[itemIndex],
            [fieldKey]: value
        };
        updatedCategories[categoryKey] = updatedItems;
        setSelectedCategories(updatedCategories);

        // If scope field changed to "Change Order", update the default for this category
        if (fieldKey === 'scope' && value === 'Change Order') {
            setScopeDefaults(prev => ({
                ...prev,
                [categoryKey]: 'Change Order'
            }));
        }
    }, [selectedCategories]);

    const addNewLineItem = useCallback((categoryKey) => {
        const updatedCategories = { ...selectedCategories };
        const defaultScope = scopeDefaults[categoryKey] || 'Original';
        const currentItems = updatedCategories[categoryKey];
        
        // Get the area from the last row if it exists
        const previousArea = currentItems.length > 0 ? currentItems[currentItems.length - 1].area : '';
        
        updatedCategories[categoryKey] = [...currentItems, { 
            scope: defaultScope,
            area: previousArea || ''
        }];
        setSelectedCategories(updatedCategories);
        
        // Return the new row index for focusing
        return updatedCategories[categoryKey].length - 1;
    }, [selectedCategories, scopeDefaults]);

    const handleKeyDown = (e, categoryKey, itemIndex, fieldKey, isLastField) => {
        if (e.key === 'Tab' && !e.shiftKey && isLastField) {
            e.preventDefault();
            const newRowIndex = addNewLineItem(categoryKey);
            // Focus the second field of the new row (index 1)
            setTimeout(() => {
                const secondInput = document.querySelector(
                    `[data-category="${categoryKey}"][data-row="${newRowIndex}"][data-field-index="1"]`
                );
                if (secondInput) {
                    secondInput.focus();
                }
            }, 0);
        }
    };

    const removeLineItem = (categoryKey, itemIndex) => {
        const updatedCategories = { ...selectedCategories };
        updatedCategories[categoryKey] = updatedCategories[categoryKey].filter((_, index) => index !== itemIndex);
        setSelectedCategories(updatedCategories);
    };

    const handleCancelAddingItems = () => {
        // Check if there are any rows in selectedCategories
        const hasRows = Object.keys(selectedCategories).length > 0;
        
        if (hasRows) {
            const confirmed = window.confirm('You have unsaved items. Are you sure you want to cancel?');
            if (!confirmed) {
                return;
            }
        }
        
        setAddingItems(false);
        setSelectedCategories({});
        setScopeDefaults({});
    };

    const handleCancelInitializing = () => {
        setInitializing(false);
        setInitializedFile(null);
        setInitializedError(null);
        setInitializedObject(null);
        setSubmittingInitialized(false);
    };

    const handleCloseProjectDetails = () => {
        // Check if adding items and there are rows
        if (addingItems && Object.keys(selectedCategories).length > 0) {
            const confirmed = window.confirm('You have unsaved items. Are you sure you want to close?');
            if (!confirmed) {
                return;
            }
        }
        closeProjectDetails();
    };

    const copyLinkToClipboard = (link, linkType) => {
        navigator.clipboard.writeText(link).then(() => {
            setCopiedLink(linkType);
            setTimeout(() => setCopiedLink(null), 2000);
        }).catch(err => {
            console.error('Failed to copy link:', err);
        });
    };

    const hasManualEdits = () => {
        return Object.keys(manualEdits).length > 0;
    };

    const getIssueLogsForRow = useCallback((sectionName, item) => {
        if (!item) {
            return [];
        }

        const possibleReferenceIds = [
            item.id,
            item.referenceId,
            item.referenceID,
            item.qcItemId,
            item.qcItemID,
            item.qcReferenceId,
            item.qcReferenceID
        ]
            .map(normalizeReferenceId)
            .filter((value) => value !== null);

        if (possibleReferenceIds.length === 0) {
            return [];
        }

        const uniqueReferenceIds = [...new Set(possibleReferenceIds)];
        const issuesForRow = [];
        const addedIssueIds = new Set();

        uniqueReferenceIds.forEach((referenceId) => {
            Object.entries(issueLogsByTypeAndReference).forEach(([groupKey, logs]) => {
                const keySuffix = `-${referenceId}`;
                if (!groupKey.endsWith(keySuffix)) {
                    return;
                }

                const groupType = groupKey.slice(0, groupKey.length - keySuffix.length);
                if (!issueTypeMatchesSection(groupType, sectionName)) {
                    return;
                }

                logs.forEach((log) => {
                    const dedupeKey = log?.id ?? `${log?.referenceId}-${log?.createdDate}-${log?.comments}`;
                    if (!addedIssueIds.has(dedupeKey)) {
                        addedIssueIds.add(dedupeKey);
                        issuesForRow.push(log);
                    }
                });
            });
        });

        return issuesForRow.sort((a, b) => {
            const dateA = new Date(a?.createdDate || 0).getTime();
            const dateB = new Date(b?.createdDate || 0).getTime();
            return dateB - dateA;
        });
    }, [issueLogsByTypeAndReference]);

    const getIssueStatusForRow = useCallback((sectionName, item) => {
        const rowIssues = getIssueLogsForRow(sectionName, item);
        if (rowIssues.length === 0) {
            return { status: null, issues: [] };
        }

        const hasUnresolved = rowIssues.some((issue) => !issue?.isResolved);
        return {
            status: hasUnresolved ? 'warning' : 'caution',
            issues: rowIssues
        };
    }, [getIssueLogsForRow]);

    const openIssueModal = useCallback((sectionName, displayIndex, item) => {
        const rowIssues = getIssueLogsForRow(sectionName, item);
        if (rowIssues.length === 0) {
            return;
        }

        setSelectedIssueRow({
            sectionName,
            rowNumber: displayIndex + 1,
            issues: rowIssues
        });
    }, [getIssueLogsForRow]);

    const handleManualFieldChange = useCallback((sectionName, itemIndex, fieldKey, value) => {
        const editKey = `${sectionName}-${itemIndex}`;
        
        setManualEdits(prev => ({
            ...prev,
            [editKey]: {
                ...prev[editKey],
                sectionName,
                itemIndex,
                originalItem: selectedProject.qcList[sectionName][itemIndex],
                changes: {
                    ...prev[editKey]?.changes,
                    [fieldKey]: value
                }
            }
        }));

        setEditedItems(prev => new Set(prev).add(editKey));
    }, [selectedProject]);

    const handleDateInputChange = useCallback((sectionName, itemIndex, fieldKey, value) => {
        const inputKey = `${sectionName}-${itemIndex}-${fieldKey}`;
        setDateInputs(prev => ({
            ...prev,
            [inputKey]: value
        }));
    }, []);

    const getDateInputValue = (sectionName, itemIndex, fieldKey) => {
        const inputKey = `${sectionName}-${itemIndex}-${fieldKey}`;
        if (dateInputs[inputKey] !== undefined) {
            return dateInputs[inputKey];
        }
        return formatDateToDisplay(getFieldValue(sectionName, itemIndex, fieldKey));
    };

    const clearDateInputValue = useCallback((sectionName, itemIndex, fieldKey) => {
        const inputKey = `${sectionName}-${itemIndex}-${fieldKey}`;
        setDateInputs(prev => {
            const newInputs = { ...prev };
            delete newInputs[inputKey];
            return newInputs;
        });
    }, []);

    const uploadManualEdits = async () => {
        if (!hasManualEdits()) return;

        try {
            // Convert manualEdits to the format expected by the API
            const updatesToSubmit = Object.values(manualEdits).map(edit => ({
                sectionName: edit.sectionName,
                itemIndex: edit.itemIndex,
                updates: edit.changes,
                originalItem: edit.originalItem
            }));

            const response = await QualityControlService.uploadManualEdits(
                apiToken,
                activeUser,
                selectedProject.project_number,
                updatesToSubmit
            );

            if (response.status > 199 && response.status < 300) {
                setManualEdits({});
                setEditedItems(new Set());
                setErrorMessage(null);
                updateProjectQCList(response.data.qcList);
                updateProjectStats(response.data.qcStatistics);;

            } else {
                alert(`Error: Received status code ${response.status}`);
            }
        } catch (error) {
            console.error('Error uploading manual edits:', error);
            setErrorMessage(`Error: ${error.message}`);
        }
    };

    const getFieldValue = (sectionName, itemIndex, fieldKey) => {
        const editKey = `${sectionName}-${itemIndex}`;
        const manualEdit = manualEdits[editKey];
        
        if (manualEdit && manualEdit.changes[fieldKey] !== undefined) {
            return manualEdit.changes[fieldKey];
        }
        
        return selectedProject.qcList[sectionName][itemIndex][fieldKey] || '';
    };

    const isItemEdited = (sectionName, itemIndex) => {
        return editedItems.has(`${sectionName}-${itemIndex}`);
    };

    const receivingLink = `${baseRoutePath}8a961f7d-2817-461a-b8e5-1df42651f019/${selectedProject.project_number}`;
    const installerLink = `${baseRoutePath}d4de7eec-ec1b-45fe-bf3d-32068191bc80/${selectedProject.project_number}`;
    const inspectorLink = `${baseRoutePath}ab64e496-74dd-4e7a-848f-93a7b260e560/${selectedProject.project_number}`;
    
    return(
        <div className="project-details-container">
            <div className="project-details-window" onClick={(e) => e.stopPropagation()}>
                <div className="project-details-header">
                    <h2>{selectedProject?.displayName}</h2>
                    <button className="close-button" onClick={handleCloseProjectDetails}>×</button>
                </div>
                <div className="project-details-content">
                    <div className='project-details-content-toolbar'>
                        <div className='project-details-content-toolbar-search'>
                            {   !addingItems && !initializing &&
                                <>
                                    <input 
                                        type="text" 
                                        className="qc-search-input" 
                                        placeholder="Search QC Items..." 
                                        value={searchInputValue}
                                        onChange={(e) => setSearchInputValue(e.target.value)} 
                                    />
                                    {(qcSearchText || activeFilter) && (
                                        <button 
                                            className="qc-add-button" 
                                            onClick={() => {
                                                setQcSearchText('');
                                                setSearchInputValue('');
                                                setActiveFilter(null);
                                            }}
                                            style={{
                                                height: '36px',
                                                padding: '0 16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Clear Filters
                                        </button>
                                    )}
                                </>
                            }
                            {   addingItems &&
                                <>
                                    <button className="qc-upload-button" onClick={() => getQCTemplate()}>Download Template</button>
                                    <label htmlFor="excel-upload" className="qc-file-upload-label">
                                        {importDocument ? importDocument.name : 'Choose Excel Import File...'}
                                    </label>
                                    <input 
                                        id="excel-upload"
                                        type="file" 
                                        className="qc-add-input" 
                                        accept=".xlsx,.xls,.csv"
                                        onChange={(e) => setImportDocument(e.target.files[0])}
                                        style={{ display: 'none' }}
                                    />
                                    {   importDocument && 
                                    <>
                                        <button
                                            className="qc-upload-button"
                                            disabled={importingFile}
                                            style={{
                                                opacity: importingFile ? 0.5 : 1,
                                                cursor: importingFile ? 'not-allowed' : 'pointer'
                                            }}
                                            onClick={async () => {
                                                setImportingFile(true);
                                                setErrorMessage(null);
                                                try {
                                                    await importQCList(apiToken, importDocument, setImportedQCList, setErrorMessage);
                                                } finally {
                                                    setImportingFile(false);
                                                }
                                            }}
                                        >
                                            {importingFile ? 'Importing...' : 'Upload'}
                                        </button>
                                    </>
                                    }
                                    {   hasLineItems &&
                                        <label className="qc-delete-checkbox-label">
                                            <input
                                                type="checkbox"
                                                checked={deleteNotFound}
                                                onChange={(e) => setDeleteNotFound(e.target.checked)}
                                                className="qc-delete-checkbox"
                                            />
                                            <span>Delete Records Not in Import File</span>
                                        </label>
                                    }
                                </>
                            }
                            {   initializing &&
                                <>
                                    <button className="qc-upload-button" onClick={() => getInitializedTemplate()}>Download Template</button>
                                    <label htmlFor="excel-upload" className="qc-file-upload-label">
                                        {importDocument ? importDocument.name : 'Choose Excel Import File...'}
                                    </label>
                                    <input 
                                        id="excel-upload"
                                        type="file" 
                                        className="qc-add-input" 
                                        accept=".xlsx,.xls,.csv"
                                        onChange={(e) => setInitializedFile(e.target.files[0])}
                                        style={{ display: 'none' }}
                                    />
                                    {   initializedFile && 
                                        <div>
                                            {   initializedError ?
                                                <div className="qc-file-label">{initializedError}</div>
                                                :
                                                <button className="qc-upload-button" onClick={() => {setSubmittingInitialized(true); submitInitializedFile(initializedFile, setInitializedObject, setInitializedError);}}>Upload</button>
                                            }
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        <div className='project-details-content-toolbar-links'>
                            {   !addingItems && !initializing && (
                                <>
                                    <button 
                                        className="qc-link-button" 
                                        onClick={() => copyLinkToClipboard(receivingLink, 'receiving')}
                                        title="Copy Receiving Link"
                                        style={{ marginRight: '8px' }}
                                    >
                                        {copiedLink === 'receiving' ? '✓ Copied!' : 'Copy Receiving Link'}
                                    </button>
                                    <button 
                                        className="qc-link-button" 
                                        onClick={() => copyLinkToClipboard(installerLink, 'installer')}
                                        title="Copy Install Link"
                                        style={{ marginRight: '8px' }}
                                    >
                                        {copiedLink === 'installer' ? '✓ Copied!' : 'Copy Install Link'}
                                    </button>
                                    <button 
                                        className="qc-link-button" 
                                        onClick={() => copyLinkToClipboard(inspectorLink, 'inspector')}
                                        title="Copy Inspector Link"
                                    >
                                        {copiedLink === 'inspector' ? '✓ Copied!' : 'Copy Inspector Link'}
                                    </button>
                                </>
                            )}
                        </div>
                        <div className='project-details-content-toolbar-import'>
                            {   !addingItems && !initializing && (
                                <>
                                    <button 
                                        className="qc-add-button" 
                                        onClick={handleImportUpdateClick}
                                        title="Import Update"
                                    >
                                        Import Update
                                    </button>
                                </>
                            )}
                        </div>
                        <div className='project-details-content-toolbar-report'>
                            {   !addingItems && !initializing && (
                                projectReportFilename ?
                                <button 
                                    className="qc-add-button" 
                                    onClick={() => downloadProjectSpecificReport(apiToken, projectReportFilename)}
                                    title="Download Project Report"
                                >
                                    Download Report
                                </button>
                                :
                                <button 
                                    className="qc-add-button" 
                                    onClick={() => createProjectSpecificReport(apiToken, selectedProject.project_number, setProjectReportFilename, setErrorMessage)}
                                    title="Create Project Report"
                                >
                                    Create Report
                                </button>
                            )}
                        </div>
                        <div className='project-details-content-toolbar-add'>
                            {   !addingItems && !hasManualEdits()  && !initializing &&
                                <button className="qc-add-button" onClick={() => setAddingItems(true)}>Add Line Items</button>
                            }
                            {   !addingItems && selectedProject.qcStatistics.total.total === 0 && !initializing &&
                                <button className="qc-add-button" onClick={() => setInitializing(true)}>Initialize To Current</button>
                            }
                            {   addingItems &&
                                <button className="qc-add-button" onClick={handleCancelAddingItems}>Cancel</button>
                            }
                            {   initializing &&
                                <button className="qc-add-button" onClick={handleCancelInitializing}>Cancel</button>
                            }
                        </div>
                    {   hasLineItems && (
                            <button 
                                    className="qc-add-button" 
                                    onClick={() => submitQCLists(selectedCategories,setErrorMessage,closeAddingItems,deleteNotFound)}
                                    disabled={!isSubmitEnabled}
                                    style={{
                                        opacity: isSubmitEnabled ? 1 : 0.5,
                                        cursor: isSubmitEnabled ? 'pointer' : 'not-allowed',
                                        backgroundColor: isSubmitEnabled ? undefined : '#999'
                                    }}
                                >
                                    Submit
                                </button>
                            )}
                            {   initializedFile && initializing && initializedObject && (
                                <button 
                                    className="qc-add-button" 
                                    onClick={() => submitInitializedObject(initializedObject, setInitializedError, handleCancelInitializing)}
                                >
                                    Submit
                                </button>
                            )}
                            {   hasManualEdits() && (
                                <button 
                                    className="qc-add-button" 
                                    onClick={uploadManualEdits}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        marginLeft: '8px'
                                    }}
                                >
                                    Upload Edits
                                </button>
                            )}
                    {   !addingItems && !initializing && (
                            <>
                                <div className='project-details-content-toolbar-refresh'>
                                    <button
                                        className="qc-refresh-btn"
                                        onClick={refreshSelectedProjectData}
                                        title="Refresh project data"
                                    >
                                        ↻
                                    </button>
                                </div>
                            </>
                            )
                        }
                    </div>
                    {showRefreshNotification && (
                        <div className="qc-refresh-notification">
                            Project Data Refreshed
                        </div>
                    )}
                        {   !addingItems && !initializing && (
                            <>
                            <div className="qc-content-wrapper" ref={contentWrapperRef}>
                                <div className='qc-content-summary-section'>
                                    <div
                                        className='qc-section-title qc-collapsible-title'
                                        onClick={() => setIsProjectSummaryCollapsed(prev => !prev)}
                                    >
                                        <span>Project Summary</span>
                                        <span className="qc-section-title-toggle">{isProjectSummaryCollapsed ? '▶' : '▼'}</span>
                                    </div>

                                    {!isProjectSummaryCollapsed && (selectedProject?.qcStatistics ? (
                                        <div className="qc-summary-grid">
                                            {Object.entries(selectedProject.qcStatistics)
                                                .filter(([key, value]) => typeof value === 'object' && value.displayName)
                                                .map(([categoryKey, stats]) => (
                                                <div key={categoryKey} className="qc-summary-card">
                                                    <div 
                                                        className="qc-summary-card-header"
                                                        onClick={() => handleCategoryHeaderClick(categoryKey)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: activeFilter?.category === categoryKey && !activeFilter?.filterType ? 'rgba(6, 89, 67, 0.1)' : 'transparent',
                                                            transition: 'background-color 0.2s ease'
                                                        }}
                                                    >
                                                        <h4>{stats.displayName} {activeFilter?.category === categoryKey && !activeFilter?.filterType ? '✓' : ''}</h4>
                                                        <span className="qc-summary-total">Total: {stats.total}</span>
                                                    </div>
                                                    
                                                    <div className="qc-summary-progress-bars">
                                                        <div 
                                                            className="qc-progress-item"
                                                            onClick={() => handleProgressBarClick(categoryKey, 'onsite')}
                                                            style={{
                                                                cursor: 'pointer',
                                                                opacity: activeFilter?.category === categoryKey && activeFilter?.filterType === 'onsite' ? 1 : (activeFilter ? 0.5 : 1),
                                                                transition: 'opacity 0.2s ease'
                                                            }}
                                                        >
                                                            <div className="qc-progress-label">
                                                                <span>Onsite {activeFilter?.category === categoryKey && activeFilter?.filterType === 'onsite' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                <span>{stats.onsite}/{stats.total} ({Math.round(stats.percentOnsite)}%)</span>
                                                            </div>
                                                            <div className="qc-progress-bar">
                                                                <div 
                                                                    className="qc-progress-fill qc-onsite" 
                                                                    style={{ width: `${stats.percentOnsite}%` }}
                                                                ></div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div 
                                                            className="qc-progress-item"
                                                            onClick={() => handleProgressBarClick(categoryKey, 'installed')}
                                                            style={{
                                                                cursor: 'pointer',
                                                                opacity: activeFilter?.category === categoryKey && activeFilter?.filterType === 'installed' ? 1 : (activeFilter ? 0.5 : 1),
                                                                transition: 'opacity 0.2s ease'
                                                            }}
                                                        >
                                                            <div className="qc-progress-label">
                                                                <span>Installed {activeFilter?.category === categoryKey && activeFilter?.filterType === 'installed' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                <span>{stats.installed}/{stats.total} ({Math.round(stats.percentInstalled)}%)</span>
                                                            </div>
                                                            <div className="qc-progress-bar">
                                                                <div 
                                                                    className="qc-progress-fill qc-installed" 
                                                                    style={{ width: `${stats.percentInstalled}%` }}
                                                                ></div>
                                                            </div>
                                                        </div>

                                                        <div 
                                                            className="qc-progress-item"
                                                            onClick={() => handleProgressBarClick(categoryKey, 'activeInspections')}
                                                            style={{
                                                                cursor: 'pointer',
                                                                opacity: activeFilter?.category === categoryKey && activeFilter?.filterType === 'activeInspections' ? 1 : (activeFilter ? 0.5 : 1),
                                                                transition: 'opacity 0.2s ease'
                                                            }}
                                                        >
                                                            <div className="qc-progress-label">
                                                                <span>Active Inspections {activeFilter?.category === categoryKey && activeFilter?.filterType === 'activeInspections' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                <span>{stats.activeInspections}/{stats.total} ({stats.total > 0 ? Math.round((stats.activeInspections / stats.total) * 100) : 0}%)</span>
                                                            </div>
                                                            <div className="qc-progress-bar">
                                                                <div 
                                                                    className="qc-progress-fill qc-active-inspections" 
                                                                    style={{ width: `${stats.total > 0 ? (stats.activeInspections / stats.total) * 100 : 0}%` }}
                                                                ></div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div 
                                                            className="qc-progress-item"
                                                            onClick={() => handleProgressBarClick(categoryKey, 'inspected')}
                                                            style={{
                                                                cursor: 'pointer',
                                                                opacity: activeFilter?.category === categoryKey && activeFilter?.filterType === 'inspected' ? 1 : (activeFilter ? 0.5 : 1),
                                                                transition: 'opacity 0.2s ease'
                                                            }}
                                                        >
                                                            <div className="qc-progress-label">
                                                                <span>Passed Inspection {activeFilter?.category === categoryKey && activeFilter?.filterType === 'inspected' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                <span>{stats.inspected}/{stats.total} ({Math.round(stats.percentInspected)}%)</span>
                                                            </div>
                                                            <div className="qc-progress-bar">
                                                                <div 
                                                                    className="qc-progress-fill qc-inspected" 
                                                                    style={{ width: `${stats.percentInspected}%` }}
                                                                ></div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div 
                                                            className="qc-progress-item"
                                                            onClick={() => handleProgressBarClick(categoryKey, 'failures')}
                                                            style={{
                                                                cursor: 'pointer',
                                                                opacity: activeFilter?.category === categoryKey && activeFilter?.filterType === 'failures' ? 1 : (activeFilter ? 0.5 : 1),
                                                                transition: 'opacity 0.2s ease'
                                                            }}
                                                        >
                                                            <div className="qc-progress-label">
                                                                <span>Failed Inspections {activeFilter?.category === categoryKey && activeFilter?.filterType === 'failures' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                <span>{stats.failures}/{stats.total} ({stats.total > 0 ? Math.round((stats.failures / stats.total) * 100) : 0}%)</span>
                                                            </div>
                                                            <div className="qc-progress-bar">
                                                                <div 
                                                                    className="qc-progress-fill qc-failures" 
                                                                    style={{ width: `${stats.total > 0 ? (stats.failures / stats.total) * 100 : 0}%` }}
                                                                ></div>
                                                            </div>
                                                        </div>

                                                        {stats.totalInstalls !== undefined && (
                                                            <div 
                                                                className="qc-progress-item"
                                                                style={{
                                                                    cursor: 'default',
                                                                    opacity: 1
                                                                }}
                                                            >
                                                                <div className="qc-progress-label">
                                                                    <span>Total Installs Progress</span>
                                                                    <span>{stats.totalCompletedInstalls || 0}/{stats.totalInstalls} ({Math.round(stats.percentTotalInstalls || 0)}%)</span>
                                                                </div>
                                                                <div className="qc-progress-bar">
                                                                    <div 
                                                                        className="qc-progress-fill qc-installed" 
                                                                        style={{ width: `${stats.percentTotalInstalls || 0}%` }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {stats.totalInspections !== undefined && (
                                                            <div 
                                                                className="qc-progress-item"
                                                                style={{
                                                                    cursor: 'default',
                                                                    opacity: 1
                                                                }}
                                                            >
                                                                <div className="qc-progress-label">
                                                                    <span>Total Inspections Progress</span>
                                                                    <span>{stats.totalCompleteInspections || 0}/{stats.totalInspections} ({Math.round(stats.percentTotalInspections || 0)}%)</span>
                                                                </div>
                                                                <div className="qc-progress-bar">
                                                                    <div 
                                                                        className="qc-progress-fill qc-inspected" 
                                                                        style={{ width: `${stats.percentTotalInspections || 0}%` }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {stats.typeBreakout && (
                                                        <div className="qc-type-breakout">
                                                            <div 
                                                                className="qc-type-breakout-header"
                                                                onClick={() => toggleTypeBreakout(categoryKey)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <span>{collapsedTypeBreakouts[categoryKey] ? '▶' : '▼'} Breakout by Type</span>
                                                            </div>
                                                            {!collapsedTypeBreakouts[categoryKey] && (
                                                                <div className="qc-type-breakout-content">
                                                                    {Object.entries(stats.typeBreakout).map(([typeKey, typeStats]) => (
                                                                        <div key={typeKey} className="qc-type-breakout-item">
                                                                            <div 
                                                                                className="qc-type-breakout-item-header"
                                                                                onClick={(e) => handleTypeBreakoutHeaderClick(e, categoryKey, typeKey)}
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    backgroundColor: activeFilter?.category === `${categoryKey}-${typeKey}` && !activeFilter?.filterType ? 'rgba(6, 89, 67, 0.1)' : 'transparent',
                                                                                    transition: 'background-color 0.2s ease'
                                                                                }}
                                                                            >
                                                                                <span>{typeKey}</span>
                                                                            </div>
                                                                            <div className="qc-type-breakout-progress-bars">
                                                                                <div 
                                                                                    className="qc-progress-item"
                                                                                    onClick={() => handleTypeBreakoutClick(categoryKey, typeKey, 'onsite')}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        opacity: activeFilter?.category === `${categoryKey}-${typeKey}` && activeFilter?.filterType === 'onsite' ? 1 : (activeFilter ? 0.5 : 1),
                                                                                        transition: 'opacity 0.2s ease'
                                                                                    }}
                                                                                >
                                                                                    <div className="qc-progress-label">
                                                                                        <span>Onsite {activeFilter?.category === `${categoryKey}-${typeKey}` && activeFilter?.filterType === 'onsite' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                                        <span>{typeStats.onsite}/{typeStats.total} ({Math.round(typeStats.percentOnsite)}%)</span>
                                                                                    </div>
                                                                                    <div className="qc-progress-bar">
                                                                                        <div 
                                                                                            className="qc-progress-fill qc-onsite" 
                                                                                            style={{ width: `${typeStats.percentOnsite}%` }}
                                                                                        ></div>
                                                                                    </div>
                                                                                </div>
                                                                                <div 
                                                                                    className="qc-progress-item"
                                                                                    onClick={() => handleTypeBreakoutClick(categoryKey, typeKey, 'installed')}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        opacity: activeFilter?.category === `${categoryKey}-${typeKey}` && activeFilter?.filterType === 'installed' ? 1 : (activeFilter ? 0.5 : 1),
                                                                                        transition: 'opacity 0.2s ease'
                                                                                    }}
                                                                                >
                                                                                    <div className="qc-progress-label">
                                                                                        <span>Installed {activeFilter?.category === `${categoryKey}-${typeKey}` && activeFilter?.filterType === 'installed' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                                        <span>{typeStats.installed}/{typeStats.total} ({Math.round(typeStats.percentInstalled)}%)</span>
                                                                                    </div>
                                                                                    <div className="qc-progress-bar">
                                                                                        <div 
                                                                                            className="qc-progress-fill qc-installed" 
                                                                                            style={{ width: `${typeStats.percentInstalled}%` }}
                                                                                        ></div>
                                                                                    </div>
                                                                                </div>
                                                                                <div 
                                                                                    className="qc-progress-item"
                                                                                    onClick={() => handleTypeBreakoutClick(categoryKey, typeKey, 'inspected')}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        opacity: activeFilter?.category === `${categoryKey}-${typeKey}` && activeFilter?.filterType === 'inspected' ? 1 : (activeFilter ? 0.5 : 1),
                                                                                        transition: 'opacity 0.2s ease'
                                                                                    }}
                                                                                >
                                                                                    <div className="qc-progress-label">
                                                                                        <span>Passed Inspection {activeFilter?.category === `${categoryKey}-${typeKey}` && activeFilter?.filterType === 'inspected' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                                        <span>{typeStats.inspected}/{typeStats.total} ({Math.round(typeStats.percentInspected)}%)</span>
                                                                                    </div>
                                                                                    <div className="qc-progress-bar">
                                                                                        <div 
                                                                                            className="qc-progress-fill qc-inspected" 
                                                                                            style={{ width: `${typeStats.percentInspected}%` }}
                                                                                        ></div>
                                                                                    </div>
                                                                                </div>
                                                                                <div 
                                                                                    className="qc-progress-item"
                                                                                    onClick={() => handleTypeBreakoutClick(categoryKey, typeKey, 'failures')}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        opacity: activeFilter?.category === `${categoryKey}-${typeKey}` && activeFilter?.filterType === 'failures' ? 1 : (activeFilter ? 0.5 : 1),
                                                                                        transition: 'opacity 0.2s ease'
                                                                                    }}
                                                                                >
                                                                                    <div className="qc-progress-label">
                                                                                        <span>Failed Inspections {activeFilter?.category === `${categoryKey}-${typeKey}` && activeFilter?.filterType === 'failures' ? (activeFilter?.inverted ? '✗' : '✓') : ''}</span>
                                                                                        <span>{typeStats.failures}/{typeStats.total} ({typeStats.total > 0 ? Math.round((typeStats.failures / typeStats.total) * 100) : 0}%)</span>
                                                                                    </div>
                                                                                    <div className="qc-progress-bar">
                                                                                        <div 
                                                                                            className="qc-progress-fill qc-failures" 
                                                                                            style={{ width: `${typeStats.total > 0 ? (typeStats.failures / typeStats.total) * 100 : 0}%` }}
                                                                                        ></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                    {stats.openingStats && (
                                                        <div className="qc-type-breakout">
                                                            <div 
                                                                className="qc-type-breakout-header"
                                                                onClick={() => toggleOpeningBreakout(categoryKey)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <span>{collapsedOpeningBreakouts[categoryKey] ? '▶' : '▼'} Breakout by Openings</span>
                                                            </div>
                                                            {!collapsedOpeningBreakouts[categoryKey] && (
                                                                <div className="qc-type-breakout-content">
                                                                    <div className="qc-type-breakout-progress-bars">
                                                                        <div 
                                                                            className="qc-progress-item"
                                                                            style={{
                                                                                cursor: 'default',
                                                                                opacity: 1
                                                                            }}
                                                                        >
                                                                            <div className="qc-progress-label">
                                                                                <span>Openings Onsite</span>
                                                                                <span>{stats.openingStats.openingsOnsite}/{stats.openingStats.openings} ({Math.round(stats.openingStats.openings > 0 ? (stats.openingStats.openingsOnsite / stats.openingStats.openings) * 100 : 0)}%)</span>
                                                                            </div>
                                                                            <div className="qc-progress-bar">
                                                                                <div 
                                                                                    className="qc-progress-fill qc-onsite" 
                                                                                    style={{ width: `${stats.openingStats.openings > 0 ? (stats.openingStats.openingsOnsite / stats.openingStats.openings) * 100 : 0}%` }}
                                                                                ></div>
                                                                            </div>
                                                                        </div>
                                                                        <div 
                                                                            className="qc-progress-item"
                                                                            style={{
                                                                                cursor: 'default',
                                                                                opacity: 1
                                                                            }}
                                                                        >
                                                                            <div className="qc-progress-label">
                                                                                <span>Openings Installed</span>
                                                                                <span>{stats.openingStats.openingsInstalled}/{stats.openingStats.openings} ({Math.round(stats.openingStats.openings > 0 ? (stats.openingStats.openingsInstalled / stats.openingStats.openings) * 100 : 0)}%)</span>
                                                                            </div>
                                                                            <div className="qc-progress-bar">
                                                                                <div 
                                                                                    className="qc-progress-fill qc-installed" 
                                                                                    style={{ width: `${stats.openingStats.openings > 0 ? (stats.openingStats.openingsInstalled / stats.openingStats.openings) * 100 : 0}%` }}
                                                                                ></div>
                                                                            </div>
                                                                        </div>
                                                                        <div 
                                                                            className="qc-progress-item"
                                                                            style={{
                                                                                cursor: 'default',
                                                                                opacity: 1
                                                                            }}
                                                                        >
                                                                            <div className="qc-progress-label">
                                                                                <span>Openings Inspected</span>
                                                                                <span>{stats.openingStats.openingsInspected}/{stats.openingStats.openings} ({Math.round(stats.openingStats.openings > 0 ? (stats.openingStats.openingsInspected / stats.openingStats.openings) * 100 : 0)}%)</span>
                                                                            </div>
                                                                            <div className="qc-progress-bar">
                                                                                <div 
                                                                                    className="qc-progress-fill qc-inspected" 
                                                                                    style={{ width: `${stats.openingStats.openings > 0 ? (stats.openingStats.openingsInspected / stats.openingStats.openings) * 100 : 0}%` }}
                                                                                ></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="qc-summary-loading">
                                            <div className="qc-loading-spinner"></div>
                                            <p>Loading project statistics...</p>
                                        </div>
                                    ))}
                                </div>

                                <div className='qc-content-summary-section'>
                                    <div
                                        className='qc-section-title qc-collapsible-title'
                                        onClick={() => setIsSummaryByAreaCollapsed(prev => !prev)}
                                    >
                                        <span>Summary by Area</span>
                                        <span className="qc-section-title-toggle">{isSummaryByAreaCollapsed ? '▶' : '▼'}</span>
                                    </div>

                                    {!isSummaryByAreaCollapsed && (selectedProject?.qcStatistics?.summaryByArea ? (
                                        Object.entries(selectedProject.qcStatistics.summaryByArea).length > 0 ? (
                                            Object.entries(selectedProject.qcStatistics.summaryByArea).map(([areaName, areaStats]) => {
                                                const categoryEntries = Object.entries(areaStats || {}).filter(([categoryKey, categoryStats]) => {
                                                    return categoryKey !== 'total' && categoryStats && typeof categoryStats === 'object' && categoryStats.total !== undefined;
                                                });
                                                const totalEntry = areaStats?.total && typeof areaStats.total === 'object' && areaStats.total.total !== undefined
                                                    ? ['total', areaStats.total]
                                                    : null;
                                                const displayEntries = totalEntry ? [...categoryEntries, totalEntry] : categoryEntries;

                                                return (
                                                    <div key={areaName} className="qc-summary-area-section">
                                                        <div
                                                            className="qc-summary-area-header"
                                                            onClick={() => handleAreaHeaderClick(areaName)}
                                                            style={{
                                                                cursor: 'pointer',
                                                                backgroundColor: activeFilter?.area === areaName && activeFilter?.category === 'total' && !activeFilter?.filterType ? 'rgba(6, 89, 67, 0.1)' : undefined,
                                                                transition: 'background-color 0.2s ease'
                                                            }}
                                                        >
                                                            <h4>{areaName}</h4>
                                                            <span className="qc-summary-total">
                                                                Total: {areaStats?.total?.total || 0} {activeFilter?.area === areaName && activeFilter?.category === 'total' && !activeFilter?.filterType ? '✓' : ''}
                                                            </span>
                                                        </div>

                                                        {displayEntries.length > 0 ? (
                                                            <div className="qc-summary-grid">
                                                                {displayEntries.map(([categoryKey, stats]) => (
                                                                    <div key={`${areaName}-${categoryKey}`} className="qc-summary-card">
                                                                        <div
                                                                            className="qc-summary-card-header"
                                                                            onClick={() => handleAreaCategoryHeaderClick(areaName, categoryKey)}
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                backgroundColor: activeFilter?.area === areaName && activeFilter?.category === categoryKey && !activeFilter?.filterType ? 'rgba(6, 89, 67, 0.1)' : 'transparent',
                                                                                transition: 'background-color 0.2s ease'
                                                                            }}
                                                                        >
                                                                            <h4>{getSummaryCategoryDisplayName(categoryKey)} {activeFilter?.area === areaName && activeFilter?.category === categoryKey && !activeFilter?.filterType ? '✓' : ''}</h4>
                                                                            <span className="qc-summary-total">Total: {stats.total || 0}</span>
                                                                        </div>
                                                                        {renderSummaryProgressBars(stats, areaName, categoryKey)}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <div className="qc-summary-area-empty">No category statistics available.</div>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="qc-summary-area-empty">No area summary data available.</div>
                                        )
                                    ) : (
                                        <div className="qc-summary-area-empty">No area summary data available.</div>
                                    ))}
                                </div>

                                {filteredSections.length === 0 ? (
                                    <div className="no-qc-items">
                                        <p>No quality control items found to display.</p>
                                    </div>
                                ) : (
                                    filteredSections.map((section) => {
                                        // Use precomputed, referentially-stable metadata for this category
                                        const metadata = sectionMetadata[section.name] || {
                                            categoryFields: qcCategories[section.name]?.fields || {},
                                            orderedFieldKeys: [],
                                            columnDefinitions: [],
                                            requiredFieldLeftOffsets: {}
                                        };
                                        const categoryFields = metadata.categoryFields;
                                        const orderedFieldKeys = metadata.orderedFieldKeys;
                                        const columnDefinitions = metadata.columnDefinitions;
                                        const requiredFieldLeftOffsets = metadata.requiredFieldLeftOffsets;

                                        // Pagination: only render the current page of rows for this section
                                        const totalItems = section.items.length;
                                        const totalPages = Math.max(1, Math.ceil(totalItems / QC_PAGE_SIZE));
                                        const rawPage = sectionPages[section.name] || 1;
                                        const currentPage = Math.min(rawPage, totalPages);
                                        const pageStartIndex = (currentPage - 1) * QC_PAGE_SIZE;
                                        const pageEndIndex = Math.min(pageStartIndex + QC_PAGE_SIZE, totalItems);
                                        const paginatedItems = section.items.slice(pageStartIndex, pageEndIndex);
                                        
                                        return (
                                            <div key={section.name} className="qc-section">
                                                <h3 className="qc-section-title">
                                                    {qcCategories[section.name]?.displayName || section.name.charAt(0).toUpperCase() + section.name.slice(1)}
                                                </h3>
                                                <div className="qc-table-wrapper">
                                                <div
                                                    className="qc-table-container"
                                                >
                                                    <table className="qc-table">
                                                        <colgroup>
                                                            {columnDefinitions.map((column) => (
                                                                <col key={column.key} style={{ width: column.width }} />
                                                            ))}
                                                        </colgroup>
                                                        <thead>
                                                            <tr>
                                                                <th className="qc-table-header qc-table-status-indicator" style={{ width: '5px', padding: 0, border: 'none' }}></th>
                                                                <th className="qc-table-header qc-table-row-number qc-table-frozen">#</th>
                                                                {orderedFieldKeys.map((fieldKey) => {
                                                                    const isRequired = categoryFields[fieldKey].requiredToCreate;
                                                                    const frozenClass = isRequired ? 'qc-table-frozen' : '';
                                                                    const isInspection = categoryFields[fieldKey].type === 'inspection';
                                                                    const isDate = categoryFields[fieldKey].type === 'date';
                                                                    const isTextarea = categoryFields[fieldKey].type === 'textArea';
                                                                    let displayName = categoryFields[fieldKey].displayName;
                                                                    if (isDate && displayName.endsWith(' Date')) {
                                                                        displayName = displayName.slice(0, -5);
                                                                    }
                                                                    return (
                                                                        <th
                                                                            key={fieldKey}
                                                                            className={`qc-table-header ${frozenClass} ${isInspection ? 'qc-table-inspection-header' : ''} ${isDate ? 'qc-table-date-header' : ''} ${isTextarea ? 'qc-table-textarea-header' : ''}`}
                                                                            style={isRequired ? { left: requiredFieldLeftOffsets[fieldKey] } : {}}
                                                                        >
                                                                            {displayName}
                                                                        </th>
                                                                    );
                                                                })}
                                                                <th className="qc-table-header" style={{ width: '120px' }}>Last Modified By</th>
                                                                <th className="qc-table-header" style={{ width: '100px' }}>Last Modified Date</th>
                                                                <th className="qc-table-header qc-table-issues-header">Issues</th>
                                                                <th className="qc-table-header" style={{ width: '40px', textAlign: 'center' }}>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {paginatedItems.map((item, pageRowIndex) => {
                                                                const displayIndex = pageStartIndex + pageRowIndex;
                                                                const originalIndex = item._originalIndex !== undefined ? item._originalIndex : displayIndex;
                                                                const editKey = `${section.name}-${originalIndex}`;
                                                                return (
                                                                    <QCTableRow
                                                                        key={originalIndex}
                                                                        sectionName={section.name}
                                                                        item={item}
                                                                        displayIndex={displayIndex}
                                                                        originalIndex={originalIndex}
                                                                        orderedFieldKeys={orderedFieldKeys}
                                                                        categoryFields={categoryFields}
                                                                        requiredFieldLeftOffsets={requiredFieldLeftOffsets}
                                                                        manualEdit={manualEdits[editKey]}
                                                                        isEdited={editedItems.has(editKey)}
                                                                        dateInputs={dateInputs}
                                                                        issueStatus={getIssueStatusForRow(section.name, item)}
                                                                        handleManualFieldChange={handleManualFieldChange}
                                                                        handleDateInputChange={handleDateInputChange}
                                                                        clearDateInputValue={clearDateInputValue}
                                                                        openIssueModal={openIssueModal}
                                                                    />
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                </div>
                                                {totalPages > 1 && (
                                                    <div className="qc-pagination">
                                                        <span className="qc-pagination-info">
                                                            {`Showing ${pageStartIndex + 1}-${pageEndIndex} of ${totalItems}`}
                                                        </span>
                                                        <div className="qc-pagination-controls">
                                                            <button
                                                                type="button"
                                                                className="qc-pagination-btn"
                                                                onClick={() => handleSectionPageChange(section.name, 1)}
                                                                disabled={currentPage === 1}
                                                            >
                                                                « First
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="qc-pagination-btn"
                                                                onClick={() => handleSectionPageChange(section.name, currentPage - 1)}
                                                                disabled={currentPage === 1}
                                                            >
                                                                ‹ Prev
                                                            </button>
                                                            <span className="qc-pagination-page">
                                                                {`Page ${currentPage} of ${totalPages}`}
                                                            </span>
                                                            <button
                                                                type="button"
                                                                className="qc-pagination-btn"
                                                                onClick={() => handleSectionPageChange(section.name, currentPage + 1)}
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                Next ›
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="qc-pagination-btn"
                                                                onClick={() => handleSectionPageChange(section.name, totalPages)}
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                Last »
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })
                                )}
                            </div>
</>
                        )
                    }
                    {   addingItems && !initializing && (
                        <div className="qc-add-items-section">
                            {hasLineItems && validationErrors.length > 0 && (
                                <div
                                    className="qc-validation-alert"
                                    style={{
                                        gridColumn: '1 / -1',
                                        backgroundColor: '#fff3cd',
                                        border: '1px solid #ffeeba',
                                        color: '#856404',
                                        borderRadius: '6px',
                                        padding: '12px 16px',
                                        margin: '0 0 12px 0'
                                    }}
                                >
                                    <div style={{ fontWeight: 600, marginBottom: '6px' }}>
                                        Cannot submit — please complete all required fields:
                                    </div>
                                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                        {validationErrors.map((error, index) => (
                                            <li key={index}>{error}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <div className='qc-add-items-new-sections'>
                                {Object.keys(qcCategories).map((categoryKey) => (
                                    <div 
                                        key={categoryKey} 
                                        className='qc-add-items-category'
                                        onClick={() => handleCategoryClick(categoryKey)}
                                        style={{
                                            backgroundColor: selectedCategories[categoryKey] ? 'rgba(255, 255, 255, 0.3)' : 'transparent'
                                        }}
                                    >
                                        {`${selectedCategories[categoryKey] ? '✓' : '+'} ${qcCategories[categoryKey].displayName}`}
                                    </div>
                                ))} 
                            </div>
                            <div className='qc-add-items-new-line-items'>
                                {importingFile ? (
                                    <div className="qc-import-loading-overlay">
                                        <div className="qc-loading-spinner"></div>
                                        <h3>Importing File</h3>
                                        <p>Processing your Excel import. This may take a moment for large files...</p>
                                    </div>
                                ) : Object.keys(selectedCategories).length > 0 ? (
                                    Object.entries(selectedCategories).map(([categoryKey, items]) => {
                                        const requiredFields = Object.entries(qcCategories[categoryKey].fields)
                                            .filter(([fieldKey, fieldConfig]) => fieldConfig.requiredToCreate);
                                        
                                        return (
                                            <div key={categoryKey} style={{ marginBottom: '24px', marginTop: '8px' }}>
                                                <div style={{ 
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    marginBottom: '8px',
                                                    paddingLeft: '8px'
                                                }}>
                                                    <h3 style={{ 
                                                        margin: 0,
                                                        fontSize: '16px',
                                                        fontWeight: '600',
                                                        color: 'var(--primary-color)'
                                                    }}>
                                                        {qcCategories[categoryKey].displayName}
                                                    </h3>
                                                    <button
                                                        onClick={() => addNewLineItem(categoryKey)}
                                                        style={{
                                                            background: 'var(--primary-color)',
                                                            color: 'white',
                                                            border: 'none',
                                                            padding: '4px 12px',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer',
                                                            fontSize: '12px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        + Add Row
                                                    </button>
                                                </div>
                                                
                                                {/* Excel-like table */}
                                                <div style={{ 
                                                    border: '1px solid #d0d0d0',
                                                    background: 'white',
                                                    overflow: 'auto',
                                                    paddingBottom: '20px'
                                                }}>
                                                    <table style={{ 
                                                        width: '100%',
                                                        borderCollapse: 'collapse',
                                                        fontSize: '13px',
                                                    }}>
                                                        <thead>
                                                            <tr style={{ background: '#f0f0f0' }}>
                                                                <th style={{ 
                                                                    border: '1px solid #d0d0d0',
                                                                    padding: '6px 8px',
                                                                    textAlign: 'left',
                                                                    fontWeight: '600',
                                                                    width: '40px',
                                                                    background: '#e8e8e8'
                                                                }}>#</th>
                                                                {requiredFields.map(([fieldKey, fieldConfig]) => (
                                                                    <th key={fieldKey} style={{ 
                                                                        border: '1px solid #d0d0d0',
                                                                        padding: '6px 8px',
                                                                        textAlign: 'left',
                                                                        fontWeight: '600',
                                                                        minWidth: '120px'
                                                                    }}>
                                                                        {fieldConfig.displayName}
                                                                    </th>
                                                                ))}
                                                                <th style={{ 
                                                                    border: '1px solid #d0d0d0',
                                                                    padding: '6px 8px',
                                                                    width: '60px',
                                                                    background: '#e8e8e8'
                                                                }}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {items.map((item, itemIndex) => (
                                                                <tr key={itemIndex} style={{ 
                                                                    background: itemIndex % 2 === 0 ? 'white' : '#fafafa'
                                                                }}>
                                                                    <td style={{ 
                                                                        border: '1px solid #d0d0d0',
                                                                        padding: '4px 8px',
                                                                        textAlign: 'center',
                                                                        background: '#f8f8f8',
                                                                        color: '#666',
                                                                        fontWeight: '500'
                                                                    }}>
                                                                        {itemIndex + 1}
                                                                    </td>
                                                                    {requiredFields.map(([fieldKey, fieldConfig], fieldIndex) => {
                                                                        const isLastField = fieldIndex === requiredFields.length - 1;
                                                                        return (
                                                                            <td key={fieldKey} style={{ 
                                                                                border: '1px solid #d0d0d0',
                                                                                padding: '2px'
                                                                            }}>
                                                                                {fieldKey === 'scope' ? (
                                                                                    <select
                                                                                        value={item[fieldKey] || 'Original'}
                                                                                        onChange={(e) => handleFieldChange(categoryKey, itemIndex, fieldKey, e.target.value)}
                                                                                        onKeyDown={(e) => handleKeyDown(e, categoryKey, itemIndex, fieldKey, isLastField)}
                                                                                        data-category={categoryKey}
                                                                                        data-row={itemIndex}
                                                                                        data-field-index={fieldIndex}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            border: 'none',
                                                                                            padding: '4px 6px',
                                                                                            fontSize: '13px',
                                                                                            background: 'transparent',
                                                                                            outline: 'none',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    >
                                                                                        <option value="Original">Original</option>
                                                                                        <option value="Change Order">Change Order</option>
                                                                                    </select>
                                                                                ) : fieldConfig.type === 'select' && fieldConfig.options ? (
                                                                                    <select
                                                                                        value={item[fieldKey] || ''}
                                                                                        onChange={(e) => handleFieldChange(categoryKey, itemIndex, fieldKey, e.target.value)}
                                                                                        onKeyDown={(e) => handleKeyDown(e, categoryKey, itemIndex, fieldKey, isLastField)}
                                                                                        data-category={categoryKey}
                                                                                        data-row={itemIndex}
                                                                                        data-field-index={fieldIndex}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            border: 'none',
                                                                                            padding: '4px 6px',
                                                                                            fontSize: '13px',
                                                                                            background: 'transparent',
                                                                                            outline: 'none',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    >
                                                                                        <option value="">Select...</option>
                                                                                        {fieldConfig.options.map((option) => (
                                                                                            <option key={option} value={option}>
                                                                                                {option}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                ) : (
                                                                                    <input
                                                                                        type={fieldConfig.type === 'number' ? 'number' : 'text'}
                                                                                        value={item[fieldKey] || ''}
                                                                                        onChange={(e) => handleFieldChange(categoryKey, itemIndex, fieldKey, e.target.value)}
                                                                                        onKeyDown={(e) => handleKeyDown(e, categoryKey, itemIndex, fieldKey, isLastField)}
                                                                                        data-category={categoryKey}
                                                                                        data-row={itemIndex}
                                                                                        data-field-index={fieldIndex}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            border: 'none',
                                                                                            padding: '4px 6px',
                                                                                            fontSize: '13px',
                                                                                            background: 'transparent',
                                                                                            outline: 'none'
                                                                                        }}
                                                                                        placeholder=""
                                                                                    />
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                    <td style={{ 
                                                                        border: '1px solid #d0d0d0',
                                                                        padding: '2px',
                                                                        textAlign: 'center',
                                                                        background: '#f8f8f8'
                                                                    }}>
                                                                        {items.length > 1 && (
                                                                            <button
                                                                                onClick={() => removeLineItem(categoryKey, itemIndex)}
                                                                                style={{
                                                                                    background: 'transparent',
                                                                                    color: '#dc3545',
                                                                                    border: 'none',
                                                                                    cursor: 'pointer',
                                                                                    fontSize: '16px',
                                                                                    padding: '2px 6px',
                                                                                    fontWeight: 'bold'
                                                                                }}
                                                                                title="Delete row"
                                                                            >
                                                                                ×
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div style={{ 
                                        padding: '60px 20px', 
                                        textAlign: 'center',
                                        color: '#6c757d',
                                        fontSize: '16px'
                                    }}>
                                        Select a category from the left to start adding items
                                    </div>
                                )}
                            </div>
                        </div>
                        )
                    }
                    {   initializing && (
                        <div className="qc-initializing-section">
                            {   !initializedObject && !submittingInitialized && !initializedFile && 
                                <div className="qc-initializing-message">
                                    <div className="qc-initializing-icon">📋</div>
                                    <h3>Initialize Project QC List</h3>
                                    <p>Download the initialized template, fill it out with your current project data, and upload it to populate the QC list.</p>
                                </div>
                            }
                            {   !initializedObject && !submittingInitialized && initializedFile &&
                                <div className="qc-initializing-message">
                                    <div className="qc-initializing-icon">📤</div>
                                    <h3>Ready to Upload</h3>
                                    <p>Click the "Upload" button to process your initialization file.</p>
                                </div>
                            }
                            {   !initializedObject && submittingInitialized && 
                                <div className="qc-initializing-message">
                                    <div className="qc-loading-spinner"></div>
                                    <h3>Processing File</h3>
                                    <p>Please wait while we process your initialization data...</p>
                                </div>
                            }
                            { initializedObject && 
                                <div className="qc-initialized-preview">
                                    <div className="qc-initialized-header">
                                        <div className="qc-initialized-title">
                                            <div className="qc-initialized-icon">✓</div>
                                            <div>
                                                <h3>Initialization Data Ready</h3>
                                                <p>Review the imported data below and click "Submit" to add to the project QC list.</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="qc-initialized-content">
                                        {Object.entries(initializedObject.importedData).map(([categoryKey, items]) => {
                                            const categoryConfig = qcCategories[categoryKey];
                                            if (!categoryConfig || !items || items.length === 0) return null;
                                            
                                            return (
                                                <div key={categoryKey} className="qc-initialized-category">
                                                    <div className="qc-initialized-category-header">
                                                        <h4>{categoryConfig.displayName}</h4>
                                                        <span className="qc-initialized-count">{items.length} {items.length === 1 ? 'item' : 'items'}</span>
                                                    </div>
                                                    
                                                    <div className="qc-initialized-items">
                                                        {items.map((item, itemIndex) => {
                                                            // Get all fields from the category
                                                            const fields = categoryConfig.fields || {};
                                                            const fieldEntries = Object.entries(fields);
                                                            
                                                            return (
                                                                <div key={itemIndex} className="qc-initialized-item">
                                                                    <div className="qc-initialized-item-number">#{itemIndex + 1}</div>
                                                                    <div className="qc-initialized-item-fields">
                                                                        {fieldEntries.map(([fieldKey, fieldConfig]) => {
                                                                            const value = item[fieldKey];
                                                                            if (value === null || value === undefined || value === '') return null;
                                                                            
                                                                            let displayValue = value;
                                                                            
                                                                            // Format dates
                                                                            if (fieldConfig.type === 'date' && value) {
                                                                                const date = new Date(value);
                                                                                if (!isNaN(date.getTime())) {
                                                                                    displayValue = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${String(date.getFullYear()).slice(-2)}`;
                                                                                }
                                                                            }
                                                                            
                                                                            // Format inspection values
                                                                            if (fieldConfig.type === 'inspection') {
                                                                                const inspectionClass = value === 'pass' ? 'pass' : value === 'fail' ? 'fail' : 'na';
                                                                                const inspectionSymbol = value === 'pass' ? '✓' : value === 'fail' ? '✗' : '—';
                                                                                return (
                                                                                    <div key={fieldKey} className="qc-initialized-field">
                                                                                        <span className="qc-initialized-field-label">{fieldConfig.displayName}:</span>
                                                                                        <span className={`qc-initialized-field-value qc-inspection-badge ${inspectionClass}`}>
                                                                                            {inspectionSymbol} {value}
                                                                                        </span>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            
                                                                            return (
                                                                                <div key={fieldKey} className="qc-initialized-field">
                                                                                    <span className="qc-initialized-field-label">{fieldConfig.displayName}:</span>
                                                                                    <span className="qc-initialized-field-value">{displayValue}</span>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            }
                        </div>
                    )
                    }
                </div>
            </div>
            {showImportUpdateModal && (
                <div className="pin-modal" onClick={handleImportUpdateClose}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        {importUpdateProcessing ? (
                            <>
                                <div className="import-update-loading">
                                    <div className="loading-spinner"></div>
                                    <h2>Processing Update...</h2>
                                    <p>Please wait while we process your import file.</p>
                                </div>
                            </>
                        ) : importUpdateSuccess ? (
                            <>
                                <div className="import-update-result success">
                                    <div className="result-icon">✓</div>
                                    <h2>Update Successful</h2>
                                    <p>Your import has been processed successfully.</p>
                                </div>
                            </>
                        ) : importUpdateFailure ? (
                            <>
                                <div className="import-update-result failure">
                                    <div className="result-icon">✗</div>
                                    <h2>Update Failed</h2>
                                    <p>There was an error processing your import file.</p>
                                    <button 
                                        className="import-update-close-btn"
                                        onClick={handleImportUpdateClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </>
                        ) : !importUpdatePINVerified ? (
                            <>
                                <h2>Enter PIN</h2>
                                <div className={`pin-display ${importUpdatePINError ? 'pin-error' : ''}`}>
                                    {importUpdatePINError ? 'WRONG' : importUpdatePIN.padEnd(4, '*')}
                                </div>
                                <div className="keypad">
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((digit) => (
                                        <button key={digit} onClick={() => handleImportUpdatePinDigit(digit.toString())}>
                                            {digit}
                                        </button>
                                    ))}
                                    <button onClick={handleImportUpdatePinClear}>Clear</button>
                                    <button onClick={handleImportUpdateClose}>Cancel</button>
                                </div>
                            </>
                        ) : (
                            <>
                                <h2>Import Update</h2>
                                <div className="import-update-file-section">
                                    <label htmlFor="import-update-file" className="import-update-file-label">
                                        {importUpdateFile ? importUpdateFile.name : 'Choose Excel File...'}
                                    </label>
                                    <input
                                        id="import-update-file"
                                        type="file"
                                        accept=".xlsx,.xls,.csv"
                                        onChange={handleImportUpdateFileSelect}
                                        style={{ display: 'none' }}
                                    />
                                    <div className="import-update-actions">
                                        <button 
                                            className="import-update-cancel-btn"
                                            onClick={handleImportUpdateClose}
                                        >
                                            Cancel
                                        </button>
                                        {importUpdateFile && (
                                            <button 
                                                className="import-update-submit-btn"
                                                onClick={handleImportUpdateSubmit}
                                            >
                                                Upload
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
            {selectedIssueRow && (
                <div className="qc-issues-modal-overlay" onClick={closeIssueModal}>
                    <div className="qc-issues-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="qc-issues-modal-header">
                            <h3>{`${selectedIssueRow.sectionName} • Row ${selectedIssueRow.rowNumber} Issues`}</h3>
                            <button className="qc-issues-modal-close" onClick={closeIssueModal}>×</button>
                        </div>
                        <div className="qc-issues-modal-content">
                            {issueLogsError && (
                                <div className="qc-issues-error">{issueLogsError}</div>
                            )}
                            {selectedIssueRow.issues.map((issue) => (
                                <div key={issue.id || `${issue.referenceId}-${issue.createdDate}`} className="qc-issue-log-card">
                                    <div className="qc-issue-log-header">
                                        <span className={`qc-issue-log-status ${issue.isResolved ? 'resolved' : 'unresolved'}`}>
                                            {issue.isResolved ? 'Resolved' : 'Unresolved'}
                                        </span>
                                    </div>
                                    <div className="qc-issue-log-details">
                                        <div><strong>Type:</strong> {issue.type || 'N/A'}</div>
                                        <div><strong>Failures:</strong> {issue.failures && issue.failures.toString().trim() !== '' ? issue.failures : 'N/A'}</div>
                                        <div><strong>Created By:</strong> {issue.createdBy || 'N/A'}</div>
                                        <div><strong>Created Date:</strong> {formatDateTimeToDisplay(issue.createdDate)}</div>
                                        <div><strong>Resolved By:</strong> {issue.resolvedBy || 'N/A'}</div>
                                        <div><strong>Resolved Date:</strong> {formatDateTimeToDisplay(issue.resolvedDate) || 'N/A'}</div>
                                    </div>
                                    <div className="qc-issue-log-comments">{issue.comments || 'No comments provided.'}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
});

const QualityControl = () => {
    const contextValue = useContext(Context);
    const [ projects, setProjects] = useState(null);
    const [ projectSearch, setSearch ] = useState('');
    const [ filteredProjects, setFilteredProjects ] = useState(null);
    const [ projectsError, setProjectsError ] = useState(null);
    const [ selectedProject, setSelectedProject ] = useState(null);
    const [ qcCategories, setQcCategories ] = useState(null);
    const [ branchFilters, setBranchFilters ] = useState([]);
    const [ projectFilters, setProjectFilters ] = useState([]);
    const [ showRefreshNotification, setShowRefreshNotification ] = useState(false);
    const [ reportFilename, setReportFilename ] = useState(null);
    const [ reportError, setReportError ] = useState(null);
    const [ issueLogs, setIssueLogs ] = useState([]);
    const [ issueLogsError, setIssueLogsError ] = useState(null);

    const [ timeStamp, setTimestamp ] = useState(null);

    const refreshProjectsList = () => {
        setProjects(null);
        setFilteredProjects(null);
        setProjectsError(null);
        getAllProjects(contextValue.apiToken, setProjects, setProjectsError,setTimestamp);
    };

    const generateCompleteReport = () => {
        generateCompleteQCReport(contextValue.apiToken, setReportFilename, setReportError );
    };

    useEffect(() => {
        refreshProjectsList();
        getQCCategoriesList(setQcCategories, (error) => console.error("Failed to fetch QC categories:", error));
    }, []);

    useEffect(() => {
        if (!filteredProjects) setFilteredProjects(projects);
    }, [projects]);

    useEffect(() => {
        if (projects) {
            const lowerSearch = projectSearch.toLowerCase();
            const filtered = {};
            for (const branch in projects) {
                filtered[branch] = projects[branch].filter(project => {
                    const matchesSearch = project.displayName.toLowerCase().includes(lowerSearch);
                    const matchesProjectFilter = projectFilters.length === 0 || projectFilters.includes(project.project_number);
                    return matchesSearch && matchesProjectFilter;
                });
            }
            setFilteredProjects(filtered);
        };
    }, [projectSearch, projectFilters]);

    const closeProjectDetails = () => { setSelectedProject(null); };

    const showSuccessRefreshNotification = () => {
        setShowRefreshNotification(true);
        setTimeout(() => setShowRefreshNotification(false), 3000);
    };

    useEffect(() => {
        // Fetch all project QC issue logs
        if (selectedProject && contextValue.apiToken && selectedProject.project_number) {
            getAllProjectQcIssueLogs(contextValue.apiToken, selectedProject.project_number, setIssueLogs, setIssueLogsError);
        }
    }, [selectedProject]);

    const refreshSelectedProjectData = () => {
        if (selectedProject) {
            getQCProjectData(contextValue.apiToken, selectedProject.project_number, updateProjectQCList, updateProjectStats,showSuccessRefreshNotification, (error) => console.error("Failed to refresh project data:", error));
            setIssueLogs([]);
            setIssueLogsError(null);
            if(contextValue.apiToken && selectedProject.project_number) {
                getAllProjectQcIssueLogs(contextValue.apiToken, selectedProject.project_number, setIssueLogs, setIssueLogsError);
            };
        };
    };

    const updateProjectQCList = (newQCList) => {
        let temporaryObject = selectedProject;
        temporaryObject.qcList = newQCList;
        setSelectedProject(temporaryObject);
    };

    const updateProjectStats = (newStats) => {
        let temporaryObject = selectedProject;
        temporaryObject.qcStatistics = newStats;
        setSelectedProject(temporaryObject);
    };

    const submitQCLists = (qcList,setError,closeAddingItems,deleteNotFound) => {
        console.log('Submitting QC List:', qcList);
        submitQCList(contextValue.apiToken, selectedProject.project_number, qcList, updateProjectQCList, updateProjectStats, setError, closeAddingItems, deleteNotFound);
    };

    const submitInitializedFile = (initializedFile, setInitializedObject, setError) => {
        submitCompleteInitializedFile(contextValue.apiToken, initializedFile, setInitializedObject, setError);
    };

    const submitInitializedObject = (initializedObject, setError, closeWindow) => {
        submitCompleteInitializedObject(contextValue.apiToken, selectedProject.project_number, initializedObject, setError, closeWindow, refreshSelectedProjectData);
    };

    const availableBranches = projects ? Object.keys(projects).sort((a, b) => parseInt(a) - parseInt(b)) : [];

    const projectHeaderProps = {
        apiToken: contextValue.apiToken,
        search: projectSearch,
        setSearch,
        branchFilters,
        setBranchFilters,
        availableBranches,
        refreshProjectsList,
        generateCompleteReport,
        timestamp: timeStamp,
        projectFilters,
        setProjectFilters,
        allProjects: projects,
        reportFilename,
        reportError
    };

    const projectsDisplayProps = {
        apiToken: contextValue.apiToken,
        filteredProjects,
        projectsError,
        setSelectedProject,
        branchFilters,
    };

    const projectDetailsProps = {
        apiToken: contextValue.apiToken,
        activeUser: { name: contextValue.activeUser.name, email: contextValue.activeUser.email, id: contextValue.activeUser.id },
        selectedProject,
        closeProjectDetails,
        submitQCLists,
        updateProjectQCList,
        updateProjectStats,
        qcCategories,
        refreshSelectedProjectData,
        showRefreshNotification,
        submitInitializedFile,
        submitInitializedObject,
        issueLogs,
        issueLogsError
    };

    return (
        <div className="quality-control">
            <QualityControlHeader {...projectHeaderProps} />
            <ProjectsDisplay {...projectsDisplayProps} />

            {   selectedProject && (
                    <ProjectDetails {...projectDetailsProps} />
                )
            }
        </div>
    );
};

export default QualityControl;